/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.13.2.0 (NJsonSchema v10.5.2.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import { Authentication } from "Authentication/Authentication";
import CurrentUserInformation from "Authentication/CurrentUserInformation";
import { getSessionId } from "requests/sessionId";
import { v4 as uuidv4 } from "uuid";
import * as moment from 'moment';

export class BaseClient {
  async transformOptions(options: RequestInit): Promise<RequestInit> {
    options.headers = new Headers({
      "Content-Type": "application/json;",
      Accept: "application/json",
      Authorization: `Bearer ${await Authentication.Instance.GetToken()}`,
      "sekoia.session_id": getSessionId(),
      "sekoia.correlation_id": uuidv4(),
      "sekoia.customer_id":
        CurrentUserInformation.Instance.getUserInformation().customerId,
    });

    return options;
  }

  getBaseUrl(_: string, parsedBaseUrl: string | undefined): string {
    if (parsedBaseUrl) {
      return parsedBaseUrl;
    }

    if (!process.env.REACT_APP_ATLAS_BASE_URL)
      throw new Error("REACT_APP_ATLAS_SERVICE_URL must be set in environment");

    return process.env.REACT_APP_ATLAS_BASE_URL;
  }
}

export class UserClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("https://services-atlas-dev.sekoia.one", baseUrl);
    }

    changePassword(request: ChangePasswordRequest): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/user/changepassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processChangePassword(_response);
        });
    }

    protected processChangePassword(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }

    changePasswordAnonymously(request: ChangePasswordAnonymouslyRequest): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/user/changepassword/anonymous";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processChangePasswordAnonymously(_response);
        });
    }

    protected processChangePasswordAnonymously(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }

    changePin(request: ChangePinRequest): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/user/changepin";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processChangePin(_response);
        });
    }

    protected processChangePin(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }

    getProfileInformationAboutMe(): Promise<ProfileResponse> {
        let url_ = this.baseUrl + "/api/user";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetProfileInformationAboutMe(_response);
        });
    }

    protected processGetProfileInformationAboutMe(response: Response): Promise<ProfileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProfileResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProfileResponse>(<any>null);
    }

    updateProfile(updateProfileRequest: UpdateProfileRequest): Promise<void> {
        let url_ = this.baseUrl + "/api/user";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateProfileRequest);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateProfile(_response);
        });
    }

    protected processUpdateProfile(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    getUser(userId: string | null): Promise<UserResponse> {
        let url_ = this.baseUrl + "/api/user/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetUser(_response);
        });
    }

    protected processGetUser(response: Response): Promise<UserResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserResponse>(<any>null);
    }

    getEmployeeDelegations(): Promise<DelegationResponse[]> {
        let url_ = this.baseUrl + "/api/user/delegations";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetEmployeeDelegations(_response);
        });
    }

    protected processGetEmployeeDelegations(response: Response): Promise<DelegationResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DelegationResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DelegationResponse[]>(<any>null);
    }
}

export class TagsClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("https://services-atlas-dev.sekoia.one", baseUrl);
    }

    getTagsByOrganisation(organisationId: string | null): Promise<TagResponse[]> {
        let url_ = this.baseUrl + "/api/organisations/{organisationId}/tags";
        if (organisationId === undefined || organisationId === null)
            throw new Error("The parameter 'organisationId' must be defined.");
        url_ = url_.replace("{organisationId}", encodeURIComponent("" + organisationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetTagsByOrganisation(_response);
        });
    }

    protected processGetTagsByOrganisation(response: Response): Promise<TagResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TagResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TagResponse[]>(<any>null);
    }
}

export class ResidentAccessClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("https://services-atlas-dev.sekoia.one", baseUrl);
    }

    updateResidentLoginAccess(residentId: string | null, updateResidentAccessRequest: UpdateResidentAccessRequest): Promise<void> {
        let url_ = this.baseUrl + "/api/residents/{residentId}/access";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateResidentAccessRequest);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateResidentLoginAccess(_response);
        });
    }

    protected processUpdateResidentLoginAccess(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class ResidentClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("https://services-atlas-dev.sekoia.one", baseUrl);
    }

    updateResidentStatus(id: string | null, request: UpdateResidentStatusRequest): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/resident/{id}/ResidentStatus";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateResidentStatus(_response);
        });
    }

    protected processUpdateResidentStatus(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }

    findResident(id: string | null, includeDeleted: boolean | undefined, includeLengthOfStay: boolean | undefined): Promise<ResidentResponse> {
        let url_ = this.baseUrl + "/api/resident/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (includeDeleted === null)
            throw new Error("The parameter 'includeDeleted' cannot be null.");
        else if (includeDeleted !== undefined)
            url_ += "includeDeleted=" + encodeURIComponent("" + includeDeleted) + "&";
        if (includeLengthOfStay === null)
            throw new Error("The parameter 'includeLengthOfStay' cannot be null.");
        else if (includeLengthOfStay !== undefined)
            url_ += "includeLengthOfStay=" + encodeURIComponent("" + includeLengthOfStay) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processFindResident(_response);
        });
    }

    protected processFindResident(response: Response): Promise<ResidentResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResidentResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResidentResponse>(<any>null);
    }

    findResidents(ids: string[] | null | undefined, includeDeleted: boolean | undefined, includeLengthOfStay: boolean | undefined): Promise<ResidentResponse[]> {
        let url_ = this.baseUrl + "/api/resident?";
        if (ids !== undefined && ids !== null)
            ids && ids.forEach(item => { url_ += "ids=" + encodeURIComponent("" + item) + "&"; });
        if (includeDeleted === null)
            throw new Error("The parameter 'includeDeleted' cannot be null.");
        else if (includeDeleted !== undefined)
            url_ += "includeDeleted=" + encodeURIComponent("" + includeDeleted) + "&";
        if (includeLengthOfStay === null)
            throw new Error("The parameter 'includeLengthOfStay' cannot be null.");
        else if (includeLengthOfStay !== undefined)
            url_ += "includeLengthOfStay=" + encodeURIComponent("" + includeLengthOfStay) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processFindResidents(_response);
        });
    }

    protected processFindResidents(response: Response): Promise<ResidentResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ResidentResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResidentResponse[]>(<any>null);
    }

    createResident(request: CreateResidentRequest): Promise<CreateResidentResponse> {
        let url_ = this.baseUrl + "/api/resident";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateResident(_response);
        });
    }

    protected processCreateResident(response: Response): Promise<CreateResidentResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = CreateResidentResponse.fromJS(resultData201);
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateResidentResponse>(<any>null);
    }

    getResidents(request: GetResidentsRequest): Promise<ResidentResponse[]> {
        let url_ = this.baseUrl + "/api/resident/query";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetResidents(_response);
        });
    }

    protected processGetResidents(response: Response): Promise<ResidentResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ResidentResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResidentResponse[]>(<any>null);
    }

    isResidentDuplicate(ssn: string | null | undefined, nhs: string | null | undefined, personnummer: string | null | undefined, organisationId: string | undefined): Promise<ResidentDuplicatePropertiesResponse> {
        let url_ = this.baseUrl + "/api/resident/exists?";
        if (ssn !== undefined && ssn !== null)
            url_ += "ssn=" + encodeURIComponent("" + ssn) + "&";
        if (nhs !== undefined && nhs !== null)
            url_ += "nhs=" + encodeURIComponent("" + nhs) + "&";
        if (personnummer !== undefined && personnummer !== null)
            url_ += "personnummer=" + encodeURIComponent("" + personnummer) + "&";
        if (organisationId === null)
            throw new Error("The parameter 'organisationId' cannot be null.");
        else if (organisationId !== undefined)
            url_ += "organisationId=" + encodeURIComponent("" + organisationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processIsResidentDuplicate(_response);
        });
    }

    protected processIsResidentDuplicate(response: Response): Promise<ResidentDuplicatePropertiesResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResidentDuplicatePropertiesResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResidentDuplicatePropertiesResponse>(<any>null);
    }

    residentSearch(residentSearchRequest: ResidentSearchRequest): Promise<ResidentResponse[]> {
        let url_ = this.baseUrl + "/api/resident/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(residentSearchRequest);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processResidentSearch(_response);
        });
    }

    protected processResidentSearch(response: Response): Promise<ResidentResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ResidentResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResidentResponse[]>(<any>null);
    }

    getResidentsStatus(request: ResidentsStatusRequest): Promise<ResidentStatusHistoryResponse[]> {
        let url_ = this.baseUrl + "/api/resident/status/history";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetResidentsStatus(_response);
        });
    }

    protected processGetResidentsStatus(response: Response): Promise<ResidentStatusHistoryResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ResidentStatusHistoryResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResidentStatusHistoryResponse[]>(<any>null);
    }

    updateResidentApartment(residentId: string | null, apartmentId: string | null): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/resident/{residentId}/apartments/{apartmentId}";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (apartmentId === undefined || apartmentId === null)
            throw new Error("The parameter 'apartmentId' must be defined.");
        url_ = url_.replace("{apartmentId}", encodeURIComponent("" + apartmentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "PUT",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateResidentApartment(_response);
        });
    }

    protected processUpdateResidentApartment(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }
}

export class ProfessionClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("https://services-atlas-dev.sekoia.one", baseUrl);
    }

    getProfessions(languageCode: string | null | undefined): Promise<ProfessionResponse[]> {
        let url_ = this.baseUrl + "/api/professions?";
        if (languageCode !== undefined && languageCode !== null)
            url_ += "languageCode=" + encodeURIComponent("" + languageCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetProfessions(_response);
        });
    }

    protected processGetProfessions(response: Response): Promise<ProfessionResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProfessionResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProfessionResponse[]>(<any>null);
    }
}

export class MaritalStatusClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("https://services-atlas-dev.sekoia.one", baseUrl);
    }

    getPossibleMaritalStatuses(): Promise<string[]> {
        let url_ = this.baseUrl + "/api/maritalstatus";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPossibleMaritalStatuses(_response);
        });
    }

    protected processGetPossibleMaritalStatuses(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(<any>null);
    }
}

export class LocationClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("https://services-atlas-dev.sekoia.one", baseUrl);
    }

    getLocationHierarchy(includeResidents: boolean | undefined): Promise<Customer> {
        let url_ = this.baseUrl + "/api/locations?";
        if (includeResidents === null)
            throw new Error("The parameter 'includeResidents' cannot be null.");
        else if (includeResidents !== undefined)
            url_ += "includeResidents=" + encodeURIComponent("" + includeResidents) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetLocationHierarchy(_response);
        });
    }

    protected processGetLocationHierarchy(response: Response): Promise<Customer> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Customer.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Customer>(<any>null);
    }
}

export class LocationsInternalClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("https://services-atlas-dev.sekoia.one", baseUrl);
    }

    getCustomers(): Promise<CustomerResponse[]> {
        let url_ = this.baseUrl + "/api/customers";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCustomers(_response);
        });
    }

    protected processGetCustomers(response: Response): Promise<CustomerResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CustomerResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CustomerResponse[]>(<any>null);
    }

    getCustomer(customerId: string | null, includeResidents: boolean | undefined): Promise<Customer> {
        let url_ = this.baseUrl + "/api/customers/{customerId}?";
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        if (includeResidents === null)
            throw new Error("The parameter 'includeResidents' cannot be null.");
        else if (includeResidents !== undefined)
            url_ += "includeResidents=" + encodeURIComponent("" + includeResidents) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCustomer(_response);
        });
    }

    protected processGetCustomer(response: Response): Promise<Customer> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Customer.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Customer>(<any>null);
    }

    createOrganisation(request: CreateLocationRequest): Promise<LocationIdResponse> {
        let url_ = this.baseUrl + "/api/organisations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateOrganisation(_response);
        });
    }

    protected processCreateOrganisation(response: Response): Promise<LocationIdResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = LocationIdResponse.fromJS(resultData201);
            return result201;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LocationIdResponse>(<any>null);
    }

    createDepartment(request: CreateLocationRequest): Promise<LocationIdResponse> {
        let url_ = this.baseUrl + "/api/departments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateDepartment(_response);
        });
    }

    protected processCreateDepartment(response: Response): Promise<LocationIdResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = LocationIdResponse.fromJS(resultData201);
            return result201;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LocationIdResponse>(<any>null);
    }

    createApartment(request: CreateLocationRequest): Promise<LocationIdResponse> {
        let url_ = this.baseUrl + "/api/apartments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateApartment(_response);
        });
    }

    protected processCreateApartment(response: Response): Promise<LocationIdResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = LocationIdResponse.fromJS(resultData201);
            return result201;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LocationIdResponse>(<any>null);
    }

    deleteOrganisation(organisationId: string | null): Promise<void> {
        let url_ = this.baseUrl + "/api/organisations/{organisationId}";
        if (organisationId === undefined || organisationId === null)
            throw new Error("The parameter 'organisationId' must be defined.");
        url_ = url_.replace("{organisationId}", encodeURIComponent("" + organisationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteOrganisation(_response);
        });
    }

    protected processDeleteOrganisation(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 422) {
            return response.text().then((_responseText) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = ErrorResponse.fromJS(resultData422);
            return throwException("A server side error occurred.", status, _responseText, _headers, result422);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    deleteDepartment(departmentId: string | null): Promise<void> {
        let url_ = this.baseUrl + "/api/departments/{departmentId}";
        if (departmentId === undefined || departmentId === null)
            throw new Error("The parameter 'departmentId' must be defined.");
        url_ = url_.replace("{departmentId}", encodeURIComponent("" + departmentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteDepartment(_response);
        });
    }

    protected processDeleteDepartment(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 422) {
            return response.text().then((_responseText) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = ErrorResponse.fromJS(resultData422);
            return throwException("A server side error occurred.", status, _responseText, _headers, result422);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    deleteApartment(apartmentId: string | null): Promise<void> {
        let url_ = this.baseUrl + "/api/apartments/{apartmentId}";
        if (apartmentId === undefined || apartmentId === null)
            throw new Error("The parameter 'apartmentId' must be defined.");
        url_ = url_.replace("{apartmentId}", encodeURIComponent("" + apartmentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteApartment(_response);
        });
    }

    protected processDeleteApartment(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 422) {
            return response.text().then((_responseText) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = ErrorResponse.fromJS(resultData422);
            return throwException("A server side error occurred.", status, _responseText, _headers, result422);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    renameLocation(locationId: string | null, request: RenameLocationRequest): Promise<void> {
        let url_ = this.baseUrl + "/api/locations/{locationId}";
        if (locationId === undefined || locationId === null)
            throw new Error("The parameter 'locationId' must be defined.");
        url_ = url_.replace("{locationId}", encodeURIComponent("" + locationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRenameLocation(_response);
        });
    }

    protected processRenameLocation(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    batchUpdateExternalIds(requests: UpdateExternalIdsRequest[]): Promise<void> {
        let url_ = this.baseUrl + "/api/locations/externalIds";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requests);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBatchUpdateExternalIds(_response);
        });
    }

    protected processBatchUpdateExternalIds(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class KombitInternalClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("https://services-atlas-dev.sekoia.one", baseUrl);
    }

    get(customerId: string | null): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/kombitInternal/sync/report/{customerId}";
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }
}

export class KarunaClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("https://services-atlas-dev.sekoia.one", baseUrl);
    }

    getNextScheduledRestartForKarunaDevice(deviceId: string | null): Promise<KarunaDeviceRestartResponse> {
        let url_ = this.baseUrl + "/api/karuna/device/{deviceId}/restart";
        if (deviceId === undefined || deviceId === null)
            throw new Error("The parameter 'deviceId' must be defined.");
        url_ = url_.replace("{deviceId}", encodeURIComponent("" + deviceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetNextScheduledRestartForKarunaDevice(_response);
        });
    }

    protected processGetNextScheduledRestartForKarunaDevice(response: Response): Promise<KarunaDeviceRestartResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KarunaDeviceRestartResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<KarunaDeviceRestartResponse>(<any>null);
    }
}

export class InternalContactClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("https://services-atlas-dev.sekoia.one", baseUrl);
    }

    getInternalContactsForResident(residentId: string | null): Promise<InternalContactResponse[]> {
        let url_ = this.baseUrl + "/api/residents/{residentId}/internalContacts";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetInternalContactsForResident(_response);
        });
    }

    protected processGetInternalContactsForResident(response: Response): Promise<InternalContactResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InternalContactResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InternalContactResponse[]>(<any>null);
    }

    createInternalContact(residentId: string | null, request: CreateInternalContactRequest): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/residents/{residentId}/internalContacts";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateInternalContact(_response);
        });
    }

    protected processCreateInternalContact(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }

    editInternalContact(residentId: string | null, id: string, request: EditInternalContactRequest): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/residents/{residentId}/internalcontacts/{id}";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processEditInternalContact(_response);
        });
    }

    protected processEditInternalContact(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }

    deleteInternalContact(residentId: string | null, internalContactId: string): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/residents/{residentId}/internalContacts/{internalContactId}";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (internalContactId === undefined || internalContactId === null)
            throw new Error("The parameter 'internalContactId' must be defined.");
        url_ = url_.replace("{internalContactId}", encodeURIComponent("" + internalContactId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteInternalContact(_response);
        });
    }

    protected processDeleteInternalContact(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }
}

export class EmployeeClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("https://services-atlas-dev.sekoia.one", baseUrl);
    }

    getEmployeeById(id: string | null, includeDeleted: boolean | undefined): Promise<EmployeeResponse> {
        let url_ = this.baseUrl + "/api/Employee/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (includeDeleted === null)
            throw new Error("The parameter 'includeDeleted' cannot be null.");
        else if (includeDeleted !== undefined)
            url_ += "includeDeleted=" + encodeURIComponent("" + includeDeleted) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetEmployeeById(_response);
        });
    }

    protected processGetEmployeeById(response: Response): Promise<EmployeeResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmployeeResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EmployeeResponse>(<any>null);
    }

    doesEmployeeWithEmailExist(email: string | null | undefined, organisationIds: string[] | null | undefined): Promise<EmployeeExistResponse> {
        let url_ = this.baseUrl + "/api/Employee/exists?";
        if (email !== undefined && email !== null)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        if (organisationIds !== undefined && organisationIds !== null)
            organisationIds && organisationIds.forEach(item => { url_ += "organisationIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDoesEmployeeWithEmailExist(_response);
        });
    }

    protected processDoesEmployeeWithEmailExist(response: Response): Promise<EmployeeExistResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmployeeExistResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EmployeeExistResponse>(<any>null);
    }

    getEmployees(ids: string[] | null | undefined, includeDeleted: boolean | undefined): Promise<EmployeeResponse[]> {
        let url_ = this.baseUrl + "/api/Employee?";
        if (ids !== undefined && ids !== null)
            ids && ids.forEach(item => { url_ += "ids=" + encodeURIComponent("" + item) + "&"; });
        if (includeDeleted === null)
            throw new Error("The parameter 'includeDeleted' cannot be null.");
        else if (includeDeleted !== undefined)
            url_ += "includeDeleted=" + encodeURIComponent("" + includeDeleted) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetEmployees(_response);
        });
    }

    protected processGetEmployees(response: Response): Promise<EmployeeResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EmployeeResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EmployeeResponse[]>(<any>null);
    }

    resetPassword(id: string | null): Promise<ProfileCreatedResponse> {
        let url_ = this.baseUrl + "/api/Employee/{id}/resetpassword";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processResetPassword(_response);
        });
    }

    protected processResetPassword(response: Response): Promise<ProfileCreatedResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProfileCreatedResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProfileCreatedResponse>(<any>null);
    }

    resetPin(id: string | null): Promise<ProfileCreatedResponse> {
        let url_ = this.baseUrl + "/api/Employee/{id}/resetpin";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processResetPin(_response);
        });
    }

    protected processResetPin(response: Response): Promise<ProfileCreatedResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProfileCreatedResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProfileCreatedResponse>(<any>null);
    }

    deleteEmployee(employeeId: string | null): Promise<void> {
        let url_ = this.baseUrl + "/api/Employee/{employeeId}";
        if (employeeId === undefined || employeeId === null)
            throw new Error("The parameter 'employeeId' must be defined.");
        url_ = url_.replace("{employeeId}", encodeURIComponent("" + employeeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteEmployee(_response);
        });
    }

    protected processDeleteEmployee(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    updateEmployee(employeeId: string | null, request: UpdateEmployeeRequest): Promise<void> {
        let url_ = this.baseUrl + "/api/Employee/{employeeId}";
        if (employeeId === undefined || employeeId === null)
            throw new Error("The parameter 'employeeId' must be defined.");
        url_ = url_.replace("{employeeId}", encodeURIComponent("" + employeeId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateEmployee(_response);
        });
    }

    protected processUpdateEmployee(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    getEmployeeAccessControlTags(id: string | null): Promise<EmployeeAccessControlTagResponse[]> {
        let url_ = this.baseUrl + "/api/Employee/{id}/accesscontroltags";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetEmployeeAccessControlTags(_response);
        });
    }

    protected processGetEmployeeAccessControlTags(response: Response): Promise<EmployeeAccessControlTagResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EmployeeAccessControlTagResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EmployeeAccessControlTagResponse[]>(<any>null);
    }

    removeAccessControlTag(employeeId: string | null, accessControlTagId: string): Promise<void> {
        let url_ = this.baseUrl + "/api/Employee/{employeeId}/accesscontroltags/{accessControlTagId}";
        if (employeeId === undefined || employeeId === null)
            throw new Error("The parameter 'employeeId' must be defined.");
        url_ = url_.replace("{employeeId}", encodeURIComponent("" + employeeId));
        if (accessControlTagId === undefined || accessControlTagId === null)
            throw new Error("The parameter 'accessControlTagId' must be defined.");
        url_ = url_.replace("{accessControlTagId}", encodeURIComponent("" + accessControlTagId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRemoveAccessControlTag(_response);
        });
    }

    protected processRemoveAccessControlTag(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    upsertAccessControlTag(employeeId: string | null, accessControlTagId: string, request: UpdateAccessControlTagRequest): Promise<void> {
        let url_ = this.baseUrl + "/api/Employee/{employeeId}/accesscontroltags/{accessControlTagId}";
        if (employeeId === undefined || employeeId === null)
            throw new Error("The parameter 'employeeId' must be defined.");
        url_ = url_.replace("{employeeId}", encodeURIComponent("" + employeeId));
        if (accessControlTagId === undefined || accessControlTagId === null)
            throw new Error("The parameter 'accessControlTagId' must be defined.");
        url_ = url_.replace("{accessControlTagId}", encodeURIComponent("" + accessControlTagId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpsertAccessControlTag(_response);
        });
    }

    protected processUpsertAccessControlTag(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    getEmployeesByCustomerId(customerId: string | null): Promise<EmployeeResponse[]> {
        let url_ = this.baseUrl + "/api/customers/{customerId}/employee";
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetEmployeesByCustomerId(_response);
        });
    }

    protected processGetEmployeesByCustomerId(response: Response): Promise<EmployeeResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EmployeeResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EmployeeResponse[]>(<any>null);
    }
}

export class EmployeeDelegationsClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("https://services-atlas-dev.sekoia.one", baseUrl);
    }

    createEmployeeDelegation(id: string | null, request: EmployeeDelegationRequest): Promise<DelegationIdResponse> {
        let url_ = this.baseUrl + "/api/employee/{id}/delegations";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateEmployeeDelegation(_response);
        });
    }

    protected processCreateEmployeeDelegation(response: Response): Promise<DelegationIdResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = DelegationIdResponse.fromJS(resultData201);
            return result201;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DelegationIdResponse>(<any>null);
    }

    getEmployeeDelegations(id: string | null): Promise<DelegationResponse[]> {
        let url_ = this.baseUrl + "/api/employee/{id}/delegations";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetEmployeeDelegations(_response);
        });
    }

    protected processGetEmployeeDelegations(response: Response): Promise<DelegationResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DelegationResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DelegationResponse[]>(<any>null);
    }

    deleteDelegation(employeeId: string | null, delegationId: string): Promise<void> {
        let url_ = this.baseUrl + "/api/employee/{employeeId}/delegations/{delegationId}";
        if (employeeId === undefined || employeeId === null)
            throw new Error("The parameter 'employeeId' must be defined.");
        url_ = url_.replace("{employeeId}", encodeURIComponent("" + employeeId));
        if (delegationId === undefined || delegationId === null)
            throw new Error("The parameter 'delegationId' must be defined.");
        url_ = url_.replace("{delegationId}", encodeURIComponent("" + delegationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteDelegation(_response);
        });
    }

    protected processDeleteDelegation(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    updateDelegation(employeeId: string | null, delegationId: string, request: UpdateDelegationRequest): Promise<void> {
        let url_ = this.baseUrl + "/api/employee/{employeeId}/delegations/{delegationId}";
        if (employeeId === undefined || employeeId === null)
            throw new Error("The parameter 'employeeId' must be defined.");
        url_ = url_.replace("{employeeId}", encodeURIComponent("" + employeeId));
        if (delegationId === undefined || delegationId === null)
            throw new Error("The parameter 'delegationId' must be defined.");
        url_ = url_.replace("{delegationId}", encodeURIComponent("" + delegationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateDelegation(_response);
        });
    }

    protected processUpdateDelegation(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class EmployeeLocationClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("https://services-atlas-dev.sekoia.one", baseUrl);
    }

    registerEmployeeLastLocation(registerRequest: RegisterRequest): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/EmployeeLocation/register";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(registerRequest);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRegisterEmployeeLastLocation(_response);
        });
    }

    protected processRegisterEmployeeLastLocation(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }

    getLastLoggedInLocation(employeeLegacyId: number | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/EmployeeLocation?";
        if (employeeLegacyId === null)
            throw new Error("The parameter 'employeeLegacyId' cannot be null.");
        else if (employeeLegacyId !== undefined)
            url_ += "employeeLegacyId=" + encodeURIComponent("" + employeeLegacyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetLastLoggedInLocation(_response);
        });
    }

    protected processGetLastLoggedInLocation(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }
}

export class DelegationClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("https://services-atlas-dev.sekoia.one", baseUrl);
    }

    getDelegationsByValue(value: string[] | undefined): Promise<DelegationResponse[]> {
        let url_ = this.baseUrl + "/api/delegations?";
        if (value === null)
            throw new Error("The parameter 'value' cannot be null.");
        else if (value !== undefined)
            value && value.forEach(item => { url_ += "value=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetDelegationsByValue(_response);
        });
    }

    protected processGetDelegationsByValue(response: Response): Promise<DelegationResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DelegationResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DelegationResponse[]>(<any>null);
    }

    getDelegationsExpirations(): Promise<DelegationResponse[]> {
        let url_ = this.baseUrl + "/api/delegations/delegationsExpirations";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetDelegationsExpirations(_response);
        });
    }

    protected processGetDelegationsExpirations(response: Response): Promise<DelegationResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DelegationResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DelegationResponse[]>(<any>null);
    }

    signDelegation(id: string): Promise<moment.Moment> {
        let url_ = this.baseUrl + "/api/delegations/{id}/sign";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSignDelegation(_response);
        });
    }

    protected processSignDelegation(response: Response): Promise<moment.Moment> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? moment(resultData200.toString()) : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<moment.Moment>(<any>null);
    }
}

export class CustomerStatsClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("https://services-atlas-dev.sekoia.one", baseUrl);
    }

    getCustomerStats(): Promise<CustomerStatsResponse[]> {
        let url_ = this.baseUrl + "/api/CustomerStats";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCustomerStats(_response);
        });
    }

    protected processGetCustomerStats(response: Response): Promise<CustomerStatsResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CustomerStatsResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CustomerStatsResponse[]>(<any>null);
    }
}

export class ContactClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("https://services-atlas-dev.sekoia.one", baseUrl);
    }

    getContactsForResident(residentId: string | null): Promise<ContactResponse[]> {
        let url_ = this.baseUrl + "/api/residents/{residentId}/contacts";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetContactsForResident(_response);
        });
    }

    protected processGetContactsForResident(response: Response): Promise<ContactResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ContactResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ContactResponse[]>(<any>null);
    }

    createRelative(residentId: string | null, relative: ContactRequest): Promise<CreatedContactResponse> {
        let url_ = this.baseUrl + "/api/residents/{residentId}/contacts/relatives";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(relative);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateRelative(_response);
        });
    }

    protected processCreateRelative(response: Response): Promise<CreatedContactResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = CreatedContactResponse.fromJS(resultData201);
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreatedContactResponse>(<any>null);
    }

    createExternal(residentId: string | null, external: ContactRequest): Promise<CreatedContactResponse> {
        let url_ = this.baseUrl + "/api/residents/{residentId}/contacts/external";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(external);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateExternal(_response);
        });
    }

    protected processCreateExternal(response: Response): Promise<CreatedContactResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = CreatedContactResponse.fromJS(resultData201);
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreatedContactResponse>(<any>null);
    }

    deleteRelative(residentId: string | null, id: string): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/residents/{residentId}/contacts/relatives/{id}";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteRelative(_response);
        });
    }

    protected processDeleteRelative(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }

    deleteExternal(residentId: string | null, id: string): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/residents/{residentId}/contacts/externals/{id}";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteExternal(_response);
        });
    }

    protected processDeleteExternal(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }

    editExternal(residentId: string | null, id: string, request: ContactRequest): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/residents/{residentId}/contacts/external/{id}";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processEditExternal(_response);
        });
    }

    protected processEditExternal(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }

    editRelative(residentId: string | null, id: string, request: ContactRequest): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/residents/{residentId}/contacts/relative/{id}";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processEditRelative(_response);
        });
    }

    protected processEditRelative(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }

    removeUserRelationFromContact(residentId: string | null, contactId: string): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/residents/{residentId}/contacts/{contactId}/removeUserRelation";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (contactId === undefined || contactId === null)
            throw new Error("The parameter 'contactId' must be defined.");
        url_ = url_.replace("{contactId}", encodeURIComponent("" + contactId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRemoveUserRelationFromContact(_response);
        });
    }

    protected processRemoveUserRelationFromContact(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }

    resetContactPassword(residentId: string | null, contactId: string): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/residents/{residentId}/contacts/{contactId}/resetpassword";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (contactId === undefined || contactId === null)
            throw new Error("The parameter 'contactId' must be defined.");
        url_ = url_.replace("{contactId}", encodeURIComponent("" + contactId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processResetContactPassword(_response);
        });
    }

    protected processResetContactPassword(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }

    validateKey(key: string): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/contacts/validatekey/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processValidateKey(_response);
        });
    }

    protected processValidateKey(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }
}

export class BasicInformationClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("https://services-atlas-dev.sekoia.one", baseUrl);
    }

    getBasicInformationForResident(residentId: string | null): Promise<BasicInformationResponse> {
        let url_ = this.baseUrl + "/api/residents/{residentId}/basicinformation";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetBasicInformationForResident(_response);
        });
    }

    protected processGetBasicInformationForResident(response: Response): Promise<BasicInformationResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BasicInformationResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BasicInformationResponse>(<any>null);
    }

    editBasicInformationForResident(residentId: string | null, editBasicInformationRequest: EditBasicInformationRequest): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/residents/{residentId}/basicinformation";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(editBasicInformationRequest);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processEditBasicInformationForResident(_response);
        });
    }

    protected processEditBasicInformationForResident(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }
}

export class AccessControlTagClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("https://services-atlas-dev.sekoia.one", baseUrl);
    }

    createAccessControlTag(request: CreateAccessControlTagRequest): Promise<IdResponse> {
        let url_ = this.baseUrl + "/api/accesscontroltags";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateAccessControlTag(_response);
        });
    }

    protected processCreateAccessControlTag(response: Response): Promise<IdResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = IdResponse.fromJS(resultData201);
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IdResponse>(<any>null);
    }

    getAccessControlTags(): Promise<AccessControlTagResponse[]> {
        let url_ = this.baseUrl + "/api/accesscontroltags";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAccessControlTags(_response);
        });
    }

    protected processGetAccessControlTags(response: Response): Promise<AccessControlTagResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AccessControlTagResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AccessControlTagResponse[]>(<any>null);
    }

    deleteAccessControlTag(id: string): Promise<void> {
        let url_ = this.baseUrl + "/api/accesscontroltags/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteAccessControlTag(_response);
        });
    }

    protected processDeleteAccessControlTag(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    updateAccessControlTag(id: string, request: RenameAccessControlTagRequest): Promise<void> {
        let url_ = this.baseUrl + "/api/accesscontroltags/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateAccessControlTag(_response);
        });
    }

    protected processUpdateAccessControlTag(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class ChangePasswordRequest implements IChangePasswordRequest {
    newPassword!: string;

    constructor(data?: IChangePasswordRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.newPassword = _data["newPassword"];
        }
    }

    static fromJS(data: any): ChangePasswordRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePasswordRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["newPassword"] = this.newPassword;
        return data; 
    }
}

export interface IChangePasswordRequest {
    newPassword: string;
}

export class ChangePasswordAnonymouslyRequest implements IChangePasswordAnonymouslyRequest {
    resetKey!: string;
    newPassword!: string;

    constructor(data?: IChangePasswordAnonymouslyRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resetKey = _data["resetKey"];
            this.newPassword = _data["newPassword"];
        }
    }

    static fromJS(data: any): ChangePasswordAnonymouslyRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePasswordAnonymouslyRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resetKey"] = this.resetKey;
        data["newPassword"] = this.newPassword;
        return data; 
    }
}

export interface IChangePasswordAnonymouslyRequest {
    resetKey: string;
    newPassword: string;
}

export class ChangePinRequest implements IChangePinRequest {
    newPin!: string;

    constructor(data?: IChangePinRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.newPin = _data["newPin"];
        }
    }

    static fromJS(data: any): ChangePinRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePinRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["newPin"] = this.newPin;
        return data; 
    }
}

export interface IChangePinRequest {
    newPin: string;
}

export class ProfileResponse implements IProfileResponse {
    firstName!: string;
    lastName!: string;
    displayName!: string;
    legacyId!: number;
    globalId!: string;
    email!: string;
    wantsChinabookNotificationEmail!: boolean;

    constructor(data?: IProfileResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.displayName = _data["displayName"];
            this.legacyId = _data["legacyId"];
            this.globalId = _data["globalId"];
            this.email = _data["email"];
            this.wantsChinabookNotificationEmail = _data["wantsChinabookNotificationEmail"];
        }
    }

    static fromJS(data: any): ProfileResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ProfileResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["displayName"] = this.displayName;
        data["legacyId"] = this.legacyId;
        data["globalId"] = this.globalId;
        data["email"] = this.email;
        data["wantsChinabookNotificationEmail"] = this.wantsChinabookNotificationEmail;
        return data; 
    }
}

export interface IProfileResponse {
    firstName: string;
    lastName: string;
    displayName: string;
    legacyId: number;
    globalId: string;
    email: string;
    wantsChinabookNotificationEmail: boolean;
}

export class UserResponse implements IUserResponse {
    firstName!: string;
    lastName!: string;
    displayName!: string;
    legacyId!: number;
    globalId!: string;
    deleted!: boolean;

    constructor(data?: IUserResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.displayName = _data["displayName"];
            this.legacyId = _data["legacyId"];
            this.globalId = _data["globalId"];
            this.deleted = _data["deleted"];
        }
    }

    static fromJS(data: any): UserResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UserResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["displayName"] = this.displayName;
        data["legacyId"] = this.legacyId;
        data["globalId"] = this.globalId;
        data["deleted"] = this.deleted;
        return data; 
    }
}

export interface IUserResponse {
    firstName: string;
    lastName: string;
    displayName: string;
    legacyId: number;
    globalId: string;
    deleted: boolean;
}

export class ProblemDetails implements IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;
    extensions!: { [key: string]: any; };

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.extensions = {};
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
            if (_data["extensions"]) {
                this.extensions = {} as any;
                for (let key in _data["extensions"]) {
                    if (_data["extensions"].hasOwnProperty(key))
                        (<any>this.extensions)![key] = _data["extensions"][key];
                }
            }
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        if (this.extensions) {
            data["extensions"] = {};
            for (let key in this.extensions) {
                if (this.extensions.hasOwnProperty(key))
                    (<any>data["extensions"])[key] = this.extensions[key];
            }
        }
        return data; 
    }
}

export interface IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;
    extensions: { [key: string]: any; };
}

export class UpdateProfileRequest implements IUpdateProfileRequest {
    firstName!: string;
    lastName!: string;
    displayName!: string;
    email!: string;
    wantsChinabookNotificationEmail?: boolean | undefined;

    constructor(data?: IUpdateProfileRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.displayName = _data["displayName"];
            this.email = _data["email"];
            this.wantsChinabookNotificationEmail = _data["wantsChinabookNotificationEmail"];
        }
    }

    static fromJS(data: any): UpdateProfileRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProfileRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["displayName"] = this.displayName;
        data["email"] = this.email;
        data["wantsChinabookNotificationEmail"] = this.wantsChinabookNotificationEmail;
        return data; 
    }
}

export interface IUpdateProfileRequest {
    firstName: string;
    lastName: string;
    displayName: string;
    email: string;
    wantsChinabookNotificationEmail?: boolean | undefined;
}

export class DelegationResponse implements IDelegationResponse {
    id!: string;
    employeeId?: string | undefined;
    lastUpdatedBy!: string;
    value!: string;
    type!: DelegationType;
    updatedAt!: moment.Moment;
    startTime?: moment.Moment | undefined;
    endTime?: moment.Moment | undefined;
    signedAt?: moment.Moment | undefined;
    signingRequired!: boolean;

    constructor(data?: IDelegationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.employeeId = _data["employeeId"];
            this.lastUpdatedBy = _data["lastUpdatedBy"];
            this.value = _data["value"];
            this.type = _data["type"];
            this.updatedAt = _data["updatedAt"] ? moment(_data["updatedAt"].toString()) : <any>undefined;
            this.startTime = _data["startTime"] ? moment(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? moment(_data["endTime"].toString()) : <any>undefined;
            this.signedAt = _data["signedAt"] ? moment(_data["signedAt"].toString()) : <any>undefined;
            this.signingRequired = _data["signingRequired"];
        }
    }

    static fromJS(data: any): DelegationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DelegationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["employeeId"] = this.employeeId;
        data["lastUpdatedBy"] = this.lastUpdatedBy;
        data["value"] = this.value;
        data["type"] = this.type;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["signedAt"] = this.signedAt ? this.signedAt.toISOString() : <any>undefined;
        data["signingRequired"] = this.signingRequired;
        return data; 
    }
}

export interface IDelegationResponse {
    id: string;
    employeeId?: string | undefined;
    lastUpdatedBy: string;
    value: string;
    type: DelegationType;
    updatedAt: moment.Moment;
    startTime?: moment.Moment | undefined;
    endTime?: moment.Moment | undefined;
    signedAt?: moment.Moment | undefined;
    signingRequired: boolean;
}

export enum DelegationType {
    Unknown = "Unknown",
    StandardTask = "StandardTask",
    TaskAssignment = "TaskAssignment",
    NotDispensedNexusAdministration = "NotDispensedNexusAdministration",
    DosedNexusAdministration = "DosedNexusAdministration",
    Tag = "Tag",
    MedicinePnPrescription = "MedicinePnPrescription",
}

export class TagResponse implements ITagResponse {
    id!: string;
    name!: string;
    customerId!: string;
    organisationId!: string;

    constructor(data?: ITagResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.customerId = _data["customerId"];
            this.organisationId = _data["organisationId"];
        }
    }

    static fromJS(data: any): TagResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TagResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["customerId"] = this.customerId;
        data["organisationId"] = this.organisationId;
        return data; 
    }
}

export interface ITagResponse {
    id: string;
    name: string;
    customerId: string;
    organisationId: string;
}

export class UpdateResidentAccessRequest implements IUpdateResidentAccessRequest {
    allowLogin!: boolean;
    password?: string | undefined;

    constructor(data?: IUpdateResidentAccessRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.allowLogin = _data["allowLogin"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): UpdateResidentAccessRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateResidentAccessRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["allowLogin"] = this.allowLogin;
        data["password"] = this.password;
        return data; 
    }
}

export interface IUpdateResidentAccessRequest {
    allowLogin: boolean;
    password?: string | undefined;
}

export class UpdateResidentStatusRequest implements IUpdateResidentStatusRequest {
    residentStatus!: ResidentStatusDto;

    constructor(data?: IUpdateResidentStatusRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.residentStatus = _data["residentStatus"];
        }
    }

    static fromJS(data: any): UpdateResidentStatusRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateResidentStatusRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["residentStatus"] = this.residentStatus;
        return data; 
    }
}

export interface IUpdateResidentStatusRequest {
    residentStatus: ResidentStatusDto;
}

export enum ResidentStatusDto {
    Active = "Active",
    PlannedAbsence = "PlannedAbsence",
    Hospitalized = "Hospitalized",
    Moved = "Moved",
    Deceased = "Deceased",
    PreAdmission = "PreAdmission",
}

export class ResidentResponse implements IResidentResponse {
    apartmentId!: string;
    apartmentName!: string;
    customerId!: string;
    deleted!: boolean;
    departmentId!: string;
    departmentName!: string;
    displayName!: string;
    firstname!: string;
    globalId!: string;
    isActive!: boolean;
    lastname!: string;
    legacyId!: number;
    organisationId!: string;
    organisationName!: string;
    ssn?: string | undefined;
    residentStatus!: ResidentStatusDto;
    allowLogin!: boolean;
    admission?: moment.Moment | undefined;
    discharge?: moment.Moment | undefined;
    createdAt!: moment.Moment;
    lengthOfStayInDays?: number | undefined;

    protected _discriminator: string;

    constructor(data?: IResidentResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "ResidentResponse";
    }

    init(_data?: any) {
        if (_data) {
            this.apartmentId = _data["apartmentId"];
            this.apartmentName = _data["apartmentName"];
            this.customerId = _data["customerId"];
            this.deleted = _data["deleted"];
            this.departmentId = _data["departmentId"];
            this.departmentName = _data["departmentName"];
            this.displayName = _data["displayName"];
            this.firstname = _data["firstname"];
            this.globalId = _data["globalId"];
            this.isActive = _data["isActive"];
            this.lastname = _data["lastname"];
            this.legacyId = _data["legacyId"];
            this.organisationId = _data["organisationId"];
            this.organisationName = _data["organisationName"];
            this.ssn = _data["ssn"];
            this.residentStatus = _data["residentStatus"];
            this.allowLogin = _data["allowLogin"];
            this.admission = _data["admission"] ? moment(_data["admission"].toString()) : <any>undefined;
            this.discharge = _data["discharge"] ? moment(_data["discharge"].toString()) : <any>undefined;
            this.createdAt = _data["createdAt"] ? moment(_data["createdAt"].toString()) : <any>undefined;
            this.lengthOfStayInDays = _data["lengthOfStayInDays"];
        }
    }

    static fromJS(data: any): ResidentResponse {
        data = typeof data === 'object' ? data : {};
        if (data["discriminator"] === "UkResidentResponse") {
            let result = new UkResidentResponse();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "SwedenResidentResponse") {
            let result = new SwedenResidentResponse();
            result.init(data);
            return result;
        }
        let result = new ResidentResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["discriminator"] = this._discriminator; 
        data["apartmentId"] = this.apartmentId;
        data["apartmentName"] = this.apartmentName;
        data["customerId"] = this.customerId;
        data["deleted"] = this.deleted;
        data["departmentId"] = this.departmentId;
        data["departmentName"] = this.departmentName;
        data["displayName"] = this.displayName;
        data["firstname"] = this.firstname;
        data["globalId"] = this.globalId;
        data["isActive"] = this.isActive;
        data["lastname"] = this.lastname;
        data["legacyId"] = this.legacyId;
        data["organisationId"] = this.organisationId;
        data["organisationName"] = this.organisationName;
        data["ssn"] = this.ssn;
        data["residentStatus"] = this.residentStatus;
        data["allowLogin"] = this.allowLogin;
        data["admission"] = this.admission ? this.admission.toISOString() : <any>undefined;
        data["discharge"] = this.discharge ? this.discharge.toISOString() : <any>undefined;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["lengthOfStayInDays"] = this.lengthOfStayInDays;
        return data; 
    }
}

export interface IResidentResponse {
    apartmentId: string;
    apartmentName: string;
    customerId: string;
    deleted: boolean;
    departmentId: string;
    departmentName: string;
    displayName: string;
    firstname: string;
    globalId: string;
    isActive: boolean;
    lastname: string;
    legacyId: number;
    organisationId: string;
    organisationName: string;
    ssn?: string | undefined;
    residentStatus: ResidentStatusDto;
    allowLogin: boolean;
    admission?: moment.Moment | undefined;
    discharge?: moment.Moment | undefined;
    createdAt: moment.Moment;
    lengthOfStayInDays?: number | undefined;
}

export class UkResidentResponse extends ResidentResponse implements IUkResidentResponse {
    nhs?: string | undefined;
    ni?: string | undefined;

    constructor(data?: IUkResidentResponse) {
        super(data);
        this._discriminator = "UkResidentResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.nhs = _data["nhs"];
            this.ni = _data["ni"];
        }
    }

    static fromJS(data: any): UkResidentResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UkResidentResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nhs"] = this.nhs;
        data["ni"] = this.ni;
        super.toJSON(data);
        return data; 
    }
}

export interface IUkResidentResponse extends IResidentResponse {
    nhs?: string | undefined;
    ni?: string | undefined;
}

export class SwedenResidentResponse extends ResidentResponse implements ISwedenResidentResponse {
    personnummer!: string;

    constructor(data?: ISwedenResidentResponse) {
        super(data);
        this._discriminator = "SwedenResidentResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.personnummer = _data["personnummer"];
        }
    }

    static fromJS(data: any): SwedenResidentResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SwedenResidentResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personnummer"] = this.personnummer;
        super.toJSON(data);
        return data; 
    }
}

export interface ISwedenResidentResponse extends IResidentResponse {
    personnummer: string;
}

export class GetResidentsRequest implements IGetResidentsRequest {
    residentIds?: string[] | undefined;
    includeDeleted!: boolean;
    includeLengthOfStay!: boolean;

    constructor(data?: IGetResidentsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["residentIds"])) {
                this.residentIds = [] as any;
                for (let item of _data["residentIds"])
                    this.residentIds!.push(item);
            }
            this.includeDeleted = _data["includeDeleted"];
            this.includeLengthOfStay = _data["includeLengthOfStay"];
        }
    }

    static fromJS(data: any): GetResidentsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetResidentsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.residentIds)) {
            data["residentIds"] = [];
            for (let item of this.residentIds)
                data["residentIds"].push(item);
        }
        data["includeDeleted"] = this.includeDeleted;
        data["includeLengthOfStay"] = this.includeLengthOfStay;
        return data; 
    }
}

export interface IGetResidentsRequest {
    residentIds?: string[] | undefined;
    includeDeleted: boolean;
    includeLengthOfStay: boolean;
}

export class ResidentDuplicatePropertiesResponse implements IResidentDuplicatePropertiesResponse {
    ssn!: string[];
    nhsNumber!: string[];
    personnummer!: string[];

    constructor(data?: IResidentDuplicatePropertiesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.ssn = [];
            this.nhsNumber = [];
            this.personnummer = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["ssn"])) {
                this.ssn = [] as any;
                for (let item of _data["ssn"])
                    this.ssn!.push(item);
            }
            if (Array.isArray(_data["nhsNumber"])) {
                this.nhsNumber = [] as any;
                for (let item of _data["nhsNumber"])
                    this.nhsNumber!.push(item);
            }
            if (Array.isArray(_data["personnummer"])) {
                this.personnummer = [] as any;
                for (let item of _data["personnummer"])
                    this.personnummer!.push(item);
            }
        }
    }

    static fromJS(data: any): ResidentDuplicatePropertiesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResidentDuplicatePropertiesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.ssn)) {
            data["ssn"] = [];
            for (let item of this.ssn)
                data["ssn"].push(item);
        }
        if (Array.isArray(this.nhsNumber)) {
            data["nhsNumber"] = [];
            for (let item of this.nhsNumber)
                data["nhsNumber"].push(item);
        }
        if (Array.isArray(this.personnummer)) {
            data["personnummer"] = [];
            for (let item of this.personnummer)
                data["personnummer"].push(item);
        }
        return data; 
    }
}

export interface IResidentDuplicatePropertiesResponse {
    ssn: string[];
    nhsNumber: string[];
    personnummer: string[];
}

export class ResidentSearchRequest implements IResidentSearchRequest {
    ids?: string[] | undefined;

    constructor(data?: IResidentSearchRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
        }
    }

    static fromJS(data: any): ResidentSearchRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ResidentSearchRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        return data; 
    }
}

export interface IResidentSearchRequest {
    ids?: string[] | undefined;
}

export class ResidentStatusHistoryResponse implements IResidentStatusHistoryResponse {
    residentId!: string;
    statusIntervals!: StatusIntervalResponse[];

    constructor(data?: IResidentStatusHistoryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.statusIntervals = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.residentId = _data["residentId"];
            if (Array.isArray(_data["statusIntervals"])) {
                this.statusIntervals = [] as any;
                for (let item of _data["statusIntervals"])
                    this.statusIntervals!.push(StatusIntervalResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResidentStatusHistoryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResidentStatusHistoryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["residentId"] = this.residentId;
        if (Array.isArray(this.statusIntervals)) {
            data["statusIntervals"] = [];
            for (let item of this.statusIntervals)
                data["statusIntervals"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IResidentStatusHistoryResponse {
    residentId: string;
    statusIntervals: StatusIntervalResponse[];
}

export class StatusIntervalResponse implements IStatusIntervalResponse {
    residentStatus!: ResidentStatusDto;
    from!: moment.Moment;
    to!: moment.Moment;

    constructor(data?: IStatusIntervalResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.residentStatus = _data["residentStatus"];
            this.from = _data["from"] ? moment(_data["from"].toString()) : <any>undefined;
            this.to = _data["to"] ? moment(_data["to"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): StatusIntervalResponse {
        data = typeof data === 'object' ? data : {};
        let result = new StatusIntervalResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["residentStatus"] = this.residentStatus;
        data["from"] = this.from ? this.from.toISOString() : <any>undefined;
        data["to"] = this.to ? this.to.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IStatusIntervalResponse {
    residentStatus: ResidentStatusDto;
    from: moment.Moment;
    to: moment.Moment;
}

export class ResidentsStatusRequest implements IResidentsStatusRequest {
    residentIds!: string[];
    from!: moment.Moment;
    to!: moment.Moment;

    constructor(data?: IResidentsStatusRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.residentIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["residentIds"])) {
                this.residentIds = [] as any;
                for (let item of _data["residentIds"])
                    this.residentIds!.push(item);
            }
            this.from = _data["from"] ? moment(_data["from"].toString()) : <any>undefined;
            this.to = _data["to"] ? moment(_data["to"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ResidentsStatusRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ResidentsStatusRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.residentIds)) {
            data["residentIds"] = [];
            for (let item of this.residentIds)
                data["residentIds"].push(item);
        }
        data["from"] = this.from ? this.from.toISOString() : <any>undefined;
        data["to"] = this.to ? this.to.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IResidentsStatusRequest {
    residentIds: string[];
    from: moment.Moment;
    to: moment.Moment;
}

export class CreateResidentResponse implements ICreateResidentResponse {
    residentId!: string;

    constructor(data?: ICreateResidentResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.residentId = _data["residentId"];
        }
    }

    static fromJS(data: any): CreateResidentResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateResidentResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["residentId"] = this.residentId;
        return data; 
    }
}

export interface ICreateResidentResponse {
    residentId: string;
}

export class CreateResidentRequest implements ICreateResidentRequest {
    apartmentId!: string;
    firstName!: string;
    lastName!: string;
    displayName!: string;
    dateOfBirth?: moment.Moment | undefined;
    ssn?: string | undefined;
    note?: string | undefined;
    maritalStatus?: string | undefined;
    religion?: string | undefined;
    contactInformation?: CreateContactInformationRequest | undefined;
    admission?: moment.Moment | undefined;
    discharge?: moment.Moment | undefined;

    protected _discriminator: string;

    constructor(data?: ICreateResidentRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "CreateResidentRequest";
    }

    init(_data?: any) {
        if (_data) {
            this.apartmentId = _data["apartmentId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.displayName = _data["displayName"];
            this.dateOfBirth = _data["dateOfBirth"] ? moment(_data["dateOfBirth"].toString()) : <any>undefined;
            this.ssn = _data["ssn"];
            this.note = _data["note"];
            this.maritalStatus = _data["maritalStatus"];
            this.religion = _data["religion"];
            this.contactInformation = _data["contactInformation"] ? CreateContactInformationRequest.fromJS(_data["contactInformation"]) : <any>undefined;
            this.admission = _data["admission"] ? moment(_data["admission"].toString()) : <any>undefined;
            this.discharge = _data["discharge"] ? moment(_data["discharge"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateResidentRequest {
        data = typeof data === 'object' ? data : {};
        if (data["discriminator"] === "CreateUkResidentRequest") {
            let result = new CreateUkResidentRequest();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "CreateSwedenResidentRequest") {
            let result = new CreateSwedenResidentRequest();
            result.init(data);
            return result;
        }
        let result = new CreateResidentRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["discriminator"] = this._discriminator; 
        data["apartmentId"] = this.apartmentId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["displayName"] = this.displayName;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.format('YYYY-MM-DD') : <any>undefined;
        data["ssn"] = this.ssn;
        data["note"] = this.note;
        data["maritalStatus"] = this.maritalStatus;
        data["religion"] = this.religion;
        data["contactInformation"] = this.contactInformation ? this.contactInformation.toJSON() : <any>undefined;
        data["admission"] = this.admission ? this.admission.format('YYYY-MM-DD') : <any>undefined;
        data["discharge"] = this.discharge ? this.discharge.format('YYYY-MM-DD') : <any>undefined;
        return data; 
    }
}

export interface ICreateResidentRequest {
    apartmentId: string;
    firstName: string;
    lastName: string;
    displayName: string;
    dateOfBirth?: moment.Moment | undefined;
    ssn?: string | undefined;
    note?: string | undefined;
    maritalStatus?: string | undefined;
    religion?: string | undefined;
    contactInformation?: CreateContactInformationRequest | undefined;
    admission?: moment.Moment | undefined;
    discharge?: moment.Moment | undefined;
}

export class CreateContactInformationRequest implements ICreateContactInformationRequest {
    id?: string | undefined;
    address?: CreateAddressRequest | undefined;
    addressCo?: CreateAddressRequest | undefined;
    billingAddress?: CreateAddressRequest | undefined;
    phone?: string | undefined;
    email?: string | undefined;

    constructor(data?: ICreateContactInformationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.address = _data["address"] ? CreateAddressRequest.fromJS(_data["address"]) : <any>undefined;
            this.addressCo = _data["addressCo"] ? CreateAddressRequest.fromJS(_data["addressCo"]) : <any>undefined;
            this.billingAddress = _data["billingAddress"] ? CreateAddressRequest.fromJS(_data["billingAddress"]) : <any>undefined;
            this.phone = _data["phone"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): CreateContactInformationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateContactInformationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["addressCo"] = this.addressCo ? this.addressCo.toJSON() : <any>undefined;
        data["billingAddress"] = this.billingAddress ? this.billingAddress.toJSON() : <any>undefined;
        data["phone"] = this.phone;
        data["email"] = this.email;
        return data; 
    }
}

export interface ICreateContactInformationRequest {
    id?: string | undefined;
    address?: CreateAddressRequest | undefined;
    addressCo?: CreateAddressRequest | undefined;
    billingAddress?: CreateAddressRequest | undefined;
    phone?: string | undefined;
    email?: string | undefined;
}

export class CreateAddressRequest implements ICreateAddressRequest {
    id?: string | undefined;
    streetLine?: string | undefined;
    streetLine2?: string | undefined;
    zipCode?: string | undefined;
    state?: string | undefined;
    country?: string | undefined;
    city?: string | undefined;

    constructor(data?: ICreateAddressRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.streetLine = _data["streetLine"];
            this.streetLine2 = _data["streetLine2"];
            this.zipCode = _data["zipCode"];
            this.state = _data["state"];
            this.country = _data["country"];
            this.city = _data["city"];
        }
    }

    static fromJS(data: any): CreateAddressRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAddressRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["streetLine"] = this.streetLine;
        data["streetLine2"] = this.streetLine2;
        data["zipCode"] = this.zipCode;
        data["state"] = this.state;
        data["country"] = this.country;
        data["city"] = this.city;
        return data; 
    }
}

export interface ICreateAddressRequest {
    id?: string | undefined;
    streetLine?: string | undefined;
    streetLine2?: string | undefined;
    zipCode?: string | undefined;
    state?: string | undefined;
    country?: string | undefined;
    city?: string | undefined;
}

export class CreateUkResidentRequest extends CreateResidentRequest implements ICreateUkResidentRequest {
    nhsNumber?: string | undefined;
    niNumber?: string | undefined;
    gender!: ResidentGender;
    sexualOrientation?: string | undefined;
    ethnicity?: string | undefined;
    pronouns?: string | undefined;

    constructor(data?: ICreateUkResidentRequest) {
        super(data);
        this._discriminator = "CreateUkResidentRequest";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.nhsNumber = _data["nhsNumber"];
            this.niNumber = _data["niNumber"];
            this.gender = _data["gender"];
            this.sexualOrientation = _data["sexualOrientation"];
            this.ethnicity = _data["ethnicity"];
            this.pronouns = _data["pronouns"];
        }
    }

    static fromJS(data: any): CreateUkResidentRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUkResidentRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nhsNumber"] = this.nhsNumber;
        data["niNumber"] = this.niNumber;
        data["gender"] = this.gender;
        data["sexualOrientation"] = this.sexualOrientation;
        data["ethnicity"] = this.ethnicity;
        data["pronouns"] = this.pronouns;
        super.toJSON(data);
        return data; 
    }
}

export interface ICreateUkResidentRequest extends ICreateResidentRequest {
    nhsNumber?: string | undefined;
    niNumber?: string | undefined;
    gender: ResidentGender;
    sexualOrientation?: string | undefined;
    ethnicity?: string | undefined;
    pronouns?: string | undefined;
}

export enum ResidentGender {
    None = "None",
    Male = "Male",
    Female = "Female",
    NonBinary = "NonBinary",
}

export class CreateSwedenResidentRequest extends CreateResidentRequest implements ICreateSwedenResidentRequest {
    personnummer?: string | undefined;
    flykting!: boolean;
    enpersonshushåll!: boolean;
    gallringsuntag!: boolean;
    skyddad!: boolean;
    samtyckerNationellaKvalitetsregister!: boolean;
    samtyckerBilder!: boolean;
    samtyckerOmsorgsdokumentation!: boolean;
    samtyckerVårdgivare!: boolean;
    identitetskontroll!: boolean;
    informationSomKanLedaTillSärskildVårdrutin?: string | undefined;

    constructor(data?: ICreateSwedenResidentRequest) {
        super(data);
        this._discriminator = "CreateSwedenResidentRequest";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.personnummer = _data["personnummer"];
            this.flykting = _data["flykting"];
            this.enpersonshushåll = _data["enpersonshushåll"];
            this.gallringsuntag = _data["gallringsuntag"];
            this.skyddad = _data["skyddad"];
            this.samtyckerNationellaKvalitetsregister = _data["samtyckerNationellaKvalitetsregister"];
            this.samtyckerBilder = _data["samtyckerBilder"];
            this.samtyckerOmsorgsdokumentation = _data["samtyckerOmsorgsdokumentation"];
            this.samtyckerVårdgivare = _data["samtyckerVårdgivare"];
            this.identitetskontroll = _data["identitetskontroll"];
            this.informationSomKanLedaTillSärskildVårdrutin = _data["informationSomKanLedaTillSärskildVårdrutin"];
        }
    }

    static fromJS(data: any): CreateSwedenResidentRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSwedenResidentRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personnummer"] = this.personnummer;
        data["flykting"] = this.flykting;
        data["enpersonshushåll"] = this.enpersonshushåll;
        data["gallringsuntag"] = this.gallringsuntag;
        data["skyddad"] = this.skyddad;
        data["samtyckerNationellaKvalitetsregister"] = this.samtyckerNationellaKvalitetsregister;
        data["samtyckerBilder"] = this.samtyckerBilder;
        data["samtyckerOmsorgsdokumentation"] = this.samtyckerOmsorgsdokumentation;
        data["samtyckerVårdgivare"] = this.samtyckerVårdgivare;
        data["identitetskontroll"] = this.identitetskontroll;
        data["informationSomKanLedaTillSärskildVårdrutin"] = this.informationSomKanLedaTillSärskildVårdrutin;
        super.toJSON(data);
        return data; 
    }
}

export interface ICreateSwedenResidentRequest extends ICreateResidentRequest {
    personnummer?: string | undefined;
    flykting: boolean;
    enpersonshushåll: boolean;
    gallringsuntag: boolean;
    skyddad: boolean;
    samtyckerNationellaKvalitetsregister: boolean;
    samtyckerBilder: boolean;
    samtyckerOmsorgsdokumentation: boolean;
    samtyckerVårdgivare: boolean;
    identitetskontroll: boolean;
    informationSomKanLedaTillSärskildVårdrutin?: string | undefined;
}

export class ProfessionResponse implements IProfessionResponse {
    id!: number;
    language!: string;
    name!: string;
    logoTypeId!: number;

    constructor(data?: IProfessionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.language = _data["language"];
            this.name = _data["name"];
            this.logoTypeId = _data["logoTypeId"];
        }
    }

    static fromJS(data: any): ProfessionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ProfessionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["language"] = this.language;
        data["name"] = this.name;
        data["logoTypeId"] = this.logoTypeId;
        return data; 
    }
}

export interface IProfessionResponse {
    id: number;
    language: string;
    name: string;
    logoTypeId: number;
}

export class Customer implements ICustomer {
    id!: string;
    legacyId!: number;
    name!: string;
    externalId?: string | undefined;
    organisations!: Organisation[];

    constructor(data?: ICustomer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.organisations = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.legacyId = _data["legacyId"];
            this.name = _data["name"];
            this.externalId = _data["externalId"];
            if (Array.isArray(_data["organisations"])) {
                this.organisations = [] as any;
                for (let item of _data["organisations"])
                    this.organisations!.push(Organisation.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Customer {
        data = typeof data === 'object' ? data : {};
        let result = new Customer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["legacyId"] = this.legacyId;
        data["name"] = this.name;
        data["externalId"] = this.externalId;
        if (Array.isArray(this.organisations)) {
            data["organisations"] = [];
            for (let item of this.organisations)
                data["organisations"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ICustomer {
    id: string;
    legacyId: number;
    name: string;
    externalId?: string | undefined;
    organisations: Organisation[];
}

export class Organisation implements IOrganisation {
    id!: string;
    legacyId!: number;
    name!: string;
    externalIds!: string[];
    customerId!: string;
    departments!: Department[];

    constructor(data?: IOrganisation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.externalIds = [];
            this.departments = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.legacyId = _data["legacyId"];
            this.name = _data["name"];
            if (Array.isArray(_data["externalIds"])) {
                this.externalIds = [] as any;
                for (let item of _data["externalIds"])
                    this.externalIds!.push(item);
            }
            this.customerId = _data["customerId"];
            if (Array.isArray(_data["departments"])) {
                this.departments = [] as any;
                for (let item of _data["departments"])
                    this.departments!.push(Department.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Organisation {
        data = typeof data === 'object' ? data : {};
        let result = new Organisation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["legacyId"] = this.legacyId;
        data["name"] = this.name;
        if (Array.isArray(this.externalIds)) {
            data["externalIds"] = [];
            for (let item of this.externalIds)
                data["externalIds"].push(item);
        }
        data["customerId"] = this.customerId;
        if (Array.isArray(this.departments)) {
            data["departments"] = [];
            for (let item of this.departments)
                data["departments"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IOrganisation {
    id: string;
    legacyId: number;
    name: string;
    externalIds: string[];
    customerId: string;
    departments: Department[];
}

export class Department implements IDepartment {
    id!: string;
    legacyId!: number;
    name!: string;
    customerId!: string;
    organisationId!: string;
    apartments!: Apartment[];

    constructor(data?: IDepartment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.apartments = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.legacyId = _data["legacyId"];
            this.name = _data["name"];
            this.customerId = _data["customerId"];
            this.organisationId = _data["organisationId"];
            if (Array.isArray(_data["apartments"])) {
                this.apartments = [] as any;
                for (let item of _data["apartments"])
                    this.apartments!.push(Apartment.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Department {
        data = typeof data === 'object' ? data : {};
        let result = new Department();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["legacyId"] = this.legacyId;
        data["name"] = this.name;
        data["customerId"] = this.customerId;
        data["organisationId"] = this.organisationId;
        if (Array.isArray(this.apartments)) {
            data["apartments"] = [];
            for (let item of this.apartments)
                data["apartments"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IDepartment {
    id: string;
    legacyId: number;
    name: string;
    customerId: string;
    organisationId: string;
    apartments: Apartment[];
}

export class Apartment implements IApartment {
    id!: string;
    legacyId!: number;
    name!: string;
    customerId!: string;
    organisationId!: string;
    departmentId!: string;
    residents!: Resident[];

    constructor(data?: IApartment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.residents = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.legacyId = _data["legacyId"];
            this.name = _data["name"];
            this.customerId = _data["customerId"];
            this.organisationId = _data["organisationId"];
            this.departmentId = _data["departmentId"];
            if (Array.isArray(_data["residents"])) {
                this.residents = [] as any;
                for (let item of _data["residents"])
                    this.residents!.push(Resident.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Apartment {
        data = typeof data === 'object' ? data : {};
        let result = new Apartment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["legacyId"] = this.legacyId;
        data["name"] = this.name;
        data["customerId"] = this.customerId;
        data["organisationId"] = this.organisationId;
        data["departmentId"] = this.departmentId;
        if (Array.isArray(this.residents)) {
            data["residents"] = [];
            for (let item of this.residents)
                data["residents"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IApartment {
    id: string;
    legacyId: number;
    name: string;
    customerId: string;
    organisationId: string;
    departmentId: string;
    residents: Resident[];
}

export class User implements IUser {
    id!: number;
    globalId!: string;
    firstname!: string;
    lastname!: string;
    displayName!: string;
    deleted!: boolean;
    customerId!: string;
    wantsChinabookNotificationEmail!: boolean;

    constructor(data?: IUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.globalId = _data["globalId"];
            this.firstname = _data["firstname"];
            this.lastname = _data["lastname"];
            this.displayName = _data["displayName"];
            this.deleted = _data["deleted"];
            this.customerId = _data["customerId"];
            this.wantsChinabookNotificationEmail = _data["wantsChinabookNotificationEmail"];
        }
    }

    static fromJS(data: any): User {
        data = typeof data === 'object' ? data : {};
        let result = new User();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["globalId"] = this.globalId;
        data["firstname"] = this.firstname;
        data["lastname"] = this.lastname;
        data["displayName"] = this.displayName;
        data["deleted"] = this.deleted;
        data["customerId"] = this.customerId;
        data["wantsChinabookNotificationEmail"] = this.wantsChinabookNotificationEmail;
        return data; 
    }
}

export interface IUser {
    id: number;
    globalId: string;
    firstname: string;
    lastname: string;
    displayName: string;
    deleted: boolean;
    customerId: string;
    wantsChinabookNotificationEmail: boolean;
}

export class Resident extends User implements IResident {
    ssn?: string | undefined;
    isActive?: boolean | undefined;
    organisationLegacyId?: number | undefined;
    organisationId?: string | undefined;
    organisationName?: string | undefined;
    apartmentId?: string | undefined;
    apartmentName?: string | undefined;
    departmentId?: string | undefined;
    departmentName?: string | undefined;
    residentStatus!: ResidentStatus;
    allowLogin!: boolean;
    admission?: moment.Moment | undefined;
    discharge?: moment.Moment | undefined;
    createdAt!: moment.Moment;
    lengthOfStayInDays?: number | undefined;

    constructor(data?: IResident) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.ssn = _data["ssn"];
            this.isActive = _data["isActive"];
            this.organisationLegacyId = _data["organisationLegacyId"];
            this.organisationId = _data["organisationId"];
            this.organisationName = _data["organisationName"];
            this.apartmentId = _data["apartmentId"];
            this.apartmentName = _data["apartmentName"];
            this.departmentId = _data["departmentId"];
            this.departmentName = _data["departmentName"];
            this.residentStatus = _data["residentStatus"];
            this.allowLogin = _data["allowLogin"];
            this.admission = _data["admission"] ? moment(_data["admission"].toString()) : <any>undefined;
            this.discharge = _data["discharge"] ? moment(_data["discharge"].toString()) : <any>undefined;
            this.createdAt = _data["createdAt"] ? moment(_data["createdAt"].toString()) : <any>undefined;
            this.lengthOfStayInDays = _data["lengthOfStayInDays"];
        }
    }

    static fromJS(data: any): Resident {
        data = typeof data === 'object' ? data : {};
        let result = new Resident();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ssn"] = this.ssn;
        data["isActive"] = this.isActive;
        data["organisationLegacyId"] = this.organisationLegacyId;
        data["organisationId"] = this.organisationId;
        data["organisationName"] = this.organisationName;
        data["apartmentId"] = this.apartmentId;
        data["apartmentName"] = this.apartmentName;
        data["departmentId"] = this.departmentId;
        data["departmentName"] = this.departmentName;
        data["residentStatus"] = this.residentStatus;
        data["allowLogin"] = this.allowLogin;
        data["admission"] = this.admission ? this.admission.toISOString() : <any>undefined;
        data["discharge"] = this.discharge ? this.discharge.toISOString() : <any>undefined;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["lengthOfStayInDays"] = this.lengthOfStayInDays;
        super.toJSON(data);
        return data; 
    }
}

export interface IResident extends IUser {
    ssn?: string | undefined;
    isActive?: boolean | undefined;
    organisationLegacyId?: number | undefined;
    organisationId?: string | undefined;
    organisationName?: string | undefined;
    apartmentId?: string | undefined;
    apartmentName?: string | undefined;
    departmentId?: string | undefined;
    departmentName?: string | undefined;
    residentStatus: ResidentStatus;
    allowLogin: boolean;
    admission?: moment.Moment | undefined;
    discharge?: moment.Moment | undefined;
    createdAt: moment.Moment;
    lengthOfStayInDays?: number | undefined;
}

export enum ResidentStatus {
    None = "None",
    Active = "Active",
    PlannedAbsence = "PlannedAbsence",
    Hospitalized = "Hospitalized",
    Moved = "Moved",
    Deceased = "Deceased",
    PreAdmission = "PreAdmission",
}

export class CustomerResponse implements ICustomerResponse {
    id!: string;
    name!: string;
    legacyId!: number;

    constructor(data?: ICustomerResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.legacyId = _data["legacyId"];
        }
    }

    static fromJS(data: any): CustomerResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["legacyId"] = this.legacyId;
        return data; 
    }
}

export interface ICustomerResponse {
    id: string;
    name: string;
    legacyId: number;
}

export class LocationIdResponse implements ILocationIdResponse {
    id!: string;

    constructor(data?: ILocationIdResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): LocationIdResponse {
        data = typeof data === 'object' ? data : {};
        let result = new LocationIdResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data; 
    }
}

export interface ILocationIdResponse {
    id: string;
}

export class CreateLocationRequest implements ICreateLocationRequest {
    parentId!: string;
    name!: string;

    constructor(data?: ICreateLocationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parentId = _data["parentId"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CreateLocationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateLocationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentId"] = this.parentId;
        data["name"] = this.name;
        return data; 
    }
}

export interface ICreateLocationRequest {
    parentId: string;
    name: string;
}

export class ErrorResponse implements IErrorResponse {
    message!: string;

    constructor(data?: IErrorResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): ErrorResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ErrorResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        return data; 
    }
}

export interface IErrorResponse {
    message: string;
}

export class RenameLocationRequest implements IRenameLocationRequest {
    name!: string;

    constructor(data?: IRenameLocationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): RenameLocationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RenameLocationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data; 
    }
}

export interface IRenameLocationRequest {
    name: string;
}

export class UpdateExternalIdsRequest implements IUpdateExternalIdsRequest {
    globalId!: string;
    externalIds!: string[];

    constructor(data?: IUpdateExternalIdsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.externalIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.globalId = _data["globalId"];
            if (Array.isArray(_data["externalIds"])) {
                this.externalIds = [] as any;
                for (let item of _data["externalIds"])
                    this.externalIds!.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateExternalIdsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateExternalIdsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["globalId"] = this.globalId;
        if (Array.isArray(this.externalIds)) {
            data["externalIds"] = [];
            for (let item of this.externalIds)
                data["externalIds"].push(item);
        }
        return data; 
    }
}

export interface IUpdateExternalIdsRequest {
    globalId: string;
    externalIds: string[];
}

export class KarunaDeviceRestartResponse implements IKarunaDeviceRestartResponse {
    timeForNextRestart?: moment.Moment | undefined;

    constructor(data?: IKarunaDeviceRestartResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.timeForNextRestart = _data["timeForNextRestart"] ? moment(_data["timeForNextRestart"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): KarunaDeviceRestartResponse {
        data = typeof data === 'object' ? data : {};
        let result = new KarunaDeviceRestartResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timeForNextRestart"] = this.timeForNextRestart ? this.timeForNextRestart.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IKarunaDeviceRestartResponse {
    timeForNextRestart?: moment.Moment | undefined;
}

export class InternalContactResponse implements IInternalContactResponse {
    id!: string;
    note!: string;
    relation!: string;
    employeeId!: string;

    constructor(data?: IInternalContactResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.note = _data["note"];
            this.relation = _data["relation"];
            this.employeeId = _data["employeeId"];
        }
    }

    static fromJS(data: any): InternalContactResponse {
        data = typeof data === 'object' ? data : {};
        let result = new InternalContactResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["note"] = this.note;
        data["relation"] = this.relation;
        data["employeeId"] = this.employeeId;
        return data; 
    }
}

export interface IInternalContactResponse {
    id: string;
    note: string;
    relation: string;
    employeeId: string;
}

export class EditInternalContactRequest implements IEditInternalContactRequest {
    relation!: string;
    note?: string | undefined;
    employeeId!: string;

    constructor(data?: IEditInternalContactRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.relation = _data["relation"];
            this.note = _data["note"];
            this.employeeId = _data["employeeId"];
        }
    }

    static fromJS(data: any): EditInternalContactRequest {
        data = typeof data === 'object' ? data : {};
        let result = new EditInternalContactRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["relation"] = this.relation;
        data["note"] = this.note;
        data["employeeId"] = this.employeeId;
        return data; 
    }
}

export interface IEditInternalContactRequest {
    relation: string;
    note?: string | undefined;
    employeeId: string;
}

export class CreateInternalContactRequest implements ICreateInternalContactRequest {
    relation!: string;
    note?: string | undefined;
    employeeId!: string;

    constructor(data?: ICreateInternalContactRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.relation = _data["relation"];
            this.note = _data["note"];
            this.employeeId = _data["employeeId"];
        }
    }

    static fromJS(data: any): CreateInternalContactRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateInternalContactRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["relation"] = this.relation;
        data["note"] = this.note;
        data["employeeId"] = this.employeeId;
        return data; 
    }
}

export interface ICreateInternalContactRequest {
    relation: string;
    note?: string | undefined;
    employeeId: string;
}

export class EmployeeResponse implements IEmployeeResponse {
    title?: string | undefined;
    department?: string | undefined;
    id!: number;
    globalId!: string;
    firstname?: string | undefined;
    lastname?: string | undefined;
    displayName?: string | undefined;
    employeeId?: string | undefined;
    deleted!: boolean;
    customerId!: string;
    email?: string | undefined;
    pipeSeparatedEmployeeGroupIds?: string | undefined;
    professionId!: number;
    wantsChinabookNotificationEmail!: boolean;
    associatedOrganisationIds!: string[];
    roleIds!: number[];

    constructor(data?: IEmployeeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.associatedOrganisationIds = [];
            this.roleIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.department = _data["department"];
            this.id = _data["id"];
            this.globalId = _data["globalId"];
            this.firstname = _data["firstname"];
            this.lastname = _data["lastname"];
            this.displayName = _data["displayName"];
            this.employeeId = _data["employeeId"];
            this.deleted = _data["deleted"];
            this.customerId = _data["customerId"];
            this.email = _data["email"];
            this.pipeSeparatedEmployeeGroupIds = _data["pipeSeparatedEmployeeGroupIds"];
            this.professionId = _data["professionId"];
            this.wantsChinabookNotificationEmail = _data["wantsChinabookNotificationEmail"];
            if (Array.isArray(_data["associatedOrganisationIds"])) {
                this.associatedOrganisationIds = [] as any;
                for (let item of _data["associatedOrganisationIds"])
                    this.associatedOrganisationIds!.push(item);
            }
            if (Array.isArray(_data["roleIds"])) {
                this.roleIds = [] as any;
                for (let item of _data["roleIds"])
                    this.roleIds!.push(item);
            }
        }
    }

    static fromJS(data: any): EmployeeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["department"] = this.department;
        data["id"] = this.id;
        data["globalId"] = this.globalId;
        data["firstname"] = this.firstname;
        data["lastname"] = this.lastname;
        data["displayName"] = this.displayName;
        data["employeeId"] = this.employeeId;
        data["deleted"] = this.deleted;
        data["customerId"] = this.customerId;
        data["email"] = this.email;
        data["pipeSeparatedEmployeeGroupIds"] = this.pipeSeparatedEmployeeGroupIds;
        data["professionId"] = this.professionId;
        data["wantsChinabookNotificationEmail"] = this.wantsChinabookNotificationEmail;
        if (Array.isArray(this.associatedOrganisationIds)) {
            data["associatedOrganisationIds"] = [];
            for (let item of this.associatedOrganisationIds)
                data["associatedOrganisationIds"].push(item);
        }
        if (Array.isArray(this.roleIds)) {
            data["roleIds"] = [];
            for (let item of this.roleIds)
                data["roleIds"].push(item);
        }
        return data; 
    }
}

export interface IEmployeeResponse {
    title?: string | undefined;
    department?: string | undefined;
    id: number;
    globalId: string;
    firstname?: string | undefined;
    lastname?: string | undefined;
    displayName?: string | undefined;
    employeeId?: string | undefined;
    deleted: boolean;
    customerId: string;
    email?: string | undefined;
    pipeSeparatedEmployeeGroupIds?: string | undefined;
    professionId: number;
    wantsChinabookNotificationEmail: boolean;
    associatedOrganisationIds: string[];
    roleIds: number[];
}

export class EmployeeExistResponse implements IEmployeeExistResponse {
    doesEmployeeExist!: boolean;

    constructor(data?: IEmployeeExistResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.doesEmployeeExist = _data["doesEmployeeExist"];
        }
    }

    static fromJS(data: any): EmployeeExistResponse {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeExistResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["doesEmployeeExist"] = this.doesEmployeeExist;
        return data; 
    }
}

export interface IEmployeeExistResponse {
    doesEmployeeExist: boolean;
}

export class ProfileCreatedResponse implements IProfileCreatedResponse {
    password?: string | undefined;
    pin?: string | undefined;
    userId?: string | undefined;

    constructor(data?: IProfileCreatedResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.password = _data["password"];
            this.pin = _data["pin"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): ProfileCreatedResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ProfileCreatedResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["password"] = this.password;
        data["pin"] = this.pin;
        data["userId"] = this.userId;
        return data; 
    }
}

export interface IProfileCreatedResponse {
    password?: string | undefined;
    pin?: string | undefined;
    userId?: string | undefined;
}

export class EmployeeAccessControlTagResponse implements IEmployeeAccessControlTagResponse {
    id!: string;
    name!: string;
    endTime?: moment.Moment | undefined;

    constructor(data?: IEmployeeAccessControlTagResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.endTime = _data["endTime"] ? moment(_data["endTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): EmployeeAccessControlTagResponse {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeAccessControlTagResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IEmployeeAccessControlTagResponse {
    id: string;
    name: string;
    endTime?: moment.Moment | undefined;
}

export class UpdateAccessControlTagRequest implements IUpdateAccessControlTagRequest {
    endTime?: moment.Moment | undefined;

    constructor(data?: IUpdateAccessControlTagRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.endTime = _data["endTime"] ? moment(_data["endTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateAccessControlTagRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAccessControlTagRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IUpdateAccessControlTagRequest {
    endTime?: moment.Moment | undefined;
}

export class UpdateEmployeeRequest implements IUpdateEmployeeRequest {
    firstname!: string;
    lastname!: string;
    displayName!: string;
    email!: string;
    title!: string;
    employeeId?: string | undefined;
    department?: string | undefined;
    pipeSeparatedEmployeeGroupIds!: string;
    professionId!: number;
    wantsChinabookNotificationEmail!: boolean;
    organisationalUnitIds!: string[];
    roleIds!: number[];

    constructor(data?: IUpdateEmployeeRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.organisationalUnitIds = [];
            this.roleIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstname = _data["firstname"];
            this.lastname = _data["lastname"];
            this.displayName = _data["displayName"];
            this.email = _data["email"];
            this.title = _data["title"];
            this.employeeId = _data["employeeId"];
            this.department = _data["department"];
            this.pipeSeparatedEmployeeGroupIds = _data["pipeSeparatedEmployeeGroupIds"];
            this.professionId = _data["professionId"];
            this.wantsChinabookNotificationEmail = _data["wantsChinabookNotificationEmail"];
            if (Array.isArray(_data["organisationalUnitIds"])) {
                this.organisationalUnitIds = [] as any;
                for (let item of _data["organisationalUnitIds"])
                    this.organisationalUnitIds!.push(item);
            }
            if (Array.isArray(_data["roleIds"])) {
                this.roleIds = [] as any;
                for (let item of _data["roleIds"])
                    this.roleIds!.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateEmployeeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateEmployeeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstname"] = this.firstname;
        data["lastname"] = this.lastname;
        data["displayName"] = this.displayName;
        data["email"] = this.email;
        data["title"] = this.title;
        data["employeeId"] = this.employeeId;
        data["department"] = this.department;
        data["pipeSeparatedEmployeeGroupIds"] = this.pipeSeparatedEmployeeGroupIds;
        data["professionId"] = this.professionId;
        data["wantsChinabookNotificationEmail"] = this.wantsChinabookNotificationEmail;
        if (Array.isArray(this.organisationalUnitIds)) {
            data["organisationalUnitIds"] = [];
            for (let item of this.organisationalUnitIds)
                data["organisationalUnitIds"].push(item);
        }
        if (Array.isArray(this.roleIds)) {
            data["roleIds"] = [];
            for (let item of this.roleIds)
                data["roleIds"].push(item);
        }
        return data; 
    }
}

export interface IUpdateEmployeeRequest {
    firstname: string;
    lastname: string;
    displayName: string;
    email: string;
    title: string;
    employeeId?: string | undefined;
    department?: string | undefined;
    pipeSeparatedEmployeeGroupIds: string;
    professionId: number;
    wantsChinabookNotificationEmail: boolean;
    organisationalUnitIds: string[];
    roleIds: number[];
}

export class DelegationIdResponse implements IDelegationIdResponse {
    id!: string;

    constructor(data?: IDelegationIdResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DelegationIdResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DelegationIdResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data; 
    }
}

export interface IDelegationIdResponse {
    id: string;
}

export class EmployeeDelegationRequest implements IEmployeeDelegationRequest {
    value!: string;
    startTime?: moment.Moment | undefined;
    endTime?: moment.Moment | undefined;
    type!: DelegationType;

    constructor(data?: IEmployeeDelegationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.startTime = _data["startTime"] ? moment(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? moment(_data["endTime"].toString()) : <any>undefined;
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): EmployeeDelegationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeDelegationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["type"] = this.type;
        return data; 
    }
}

export interface IEmployeeDelegationRequest {
    value: string;
    startTime?: moment.Moment | undefined;
    endTime?: moment.Moment | undefined;
    type: DelegationType;
}

export class UpdateDelegationRequest implements IUpdateDelegationRequest {
    startTime?: moment.Moment | undefined;
    endTime?: moment.Moment | undefined;

    constructor(data?: IUpdateDelegationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startTime = _data["startTime"] ? moment(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? moment(_data["endTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateDelegationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDelegationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IUpdateDelegationRequest {
    startTime?: moment.Moment | undefined;
    endTime?: moment.Moment | undefined;
}

export class RegisterRequest implements IRegisterRequest {
    employeeLegacyId!: number;
    apartmentLegacyId!: number;

    constructor(data?: IRegisterRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employeeLegacyId = _data["employeeLegacyId"];
            this.apartmentLegacyId = _data["apartmentLegacyId"];
        }
    }

    static fromJS(data: any): RegisterRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeeLegacyId"] = this.employeeLegacyId;
        data["apartmentLegacyId"] = this.apartmentLegacyId;
        return data; 
    }
}

export interface IRegisterRequest {
    employeeLegacyId: number;
    apartmentLegacyId: number;
}

export class CustomerStatsResponse implements ICustomerStatsResponse {
    customerGlobalId!: string;
    customerId!: number;
    customerName!: string;
    residentsCount!: number;
    employeesCount!: number;
    contactsCount!: number;

    constructor(data?: ICustomerStatsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerGlobalId = _data["customerGlobalId"];
            this.customerId = _data["customerId"];
            this.customerName = _data["customerName"];
            this.residentsCount = _data["residentsCount"];
            this.employeesCount = _data["employeesCount"];
            this.contactsCount = _data["contactsCount"];
        }
    }

    static fromJS(data: any): CustomerStatsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerStatsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerGlobalId"] = this.customerGlobalId;
        data["customerId"] = this.customerId;
        data["customerName"] = this.customerName;
        data["residentsCount"] = this.residentsCount;
        data["employeesCount"] = this.employeesCount;
        data["contactsCount"] = this.contactsCount;
        return data; 
    }
}

export interface ICustomerStatsResponse {
    customerGlobalId: string;
    customerId: number;
    customerName: string;
    residentsCount: number;
    employeesCount: number;
    contactsCount: number;
}

export class ContactResponse implements IContactResponse {
    id!: string;
    userId?: string | undefined;
    userName?: string | undefined;
    userEmail?: string | undefined;
    firstName!: string;
    lastName!: string;
    relation!: string;
    primaryContact!: boolean;
    guardian!: boolean;
    note?: string | undefined;
    typeOfContact!: TypeOfContact;
    isPendingInvitationOrRelationActive!: boolean;
    contactInformation?: ContactInformationCompactResponse | undefined;

    constructor(data?: IContactResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.userName = _data["userName"];
            this.userEmail = _data["userEmail"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.relation = _data["relation"];
            this.primaryContact = _data["primaryContact"];
            this.guardian = _data["guardian"];
            this.note = _data["note"];
            this.typeOfContact = _data["typeOfContact"];
            this.isPendingInvitationOrRelationActive = _data["isPendingInvitationOrRelationActive"];
            this.contactInformation = _data["contactInformation"] ? ContactInformationCompactResponse.fromJS(_data["contactInformation"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ContactResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ContactResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["userEmail"] = this.userEmail;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["relation"] = this.relation;
        data["primaryContact"] = this.primaryContact;
        data["guardian"] = this.guardian;
        data["note"] = this.note;
        data["typeOfContact"] = this.typeOfContact;
        data["isPendingInvitationOrRelationActive"] = this.isPendingInvitationOrRelationActive;
        data["contactInformation"] = this.contactInformation ? this.contactInformation.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IContactResponse {
    id: string;
    userId?: string | undefined;
    userName?: string | undefined;
    userEmail?: string | undefined;
    firstName: string;
    lastName: string;
    relation: string;
    primaryContact: boolean;
    guardian: boolean;
    note?: string | undefined;
    typeOfContact: TypeOfContact;
    isPendingInvitationOrRelationActive: boolean;
    contactInformation?: ContactInformationCompactResponse | undefined;
}

export enum TypeOfContact {
    None = "None",
    Relative = "Relative",
    External = "External",
}

export class ContactInformationCompactResponse implements IContactInformationCompactResponse {
    id?: string | undefined;
    address?: AddressResponse | undefined;
    phone?: string | undefined;
    email?: string | undefined;

    constructor(data?: IContactInformationCompactResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.address = _data["address"] ? AddressResponse.fromJS(_data["address"]) : <any>undefined;
            this.phone = _data["phone"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): ContactInformationCompactResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ContactInformationCompactResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["phone"] = this.phone;
        data["email"] = this.email;
        return data; 
    }
}

export interface IContactInformationCompactResponse {
    id?: string | undefined;
    address?: AddressResponse | undefined;
    phone?: string | undefined;
    email?: string | undefined;
}

export class AddressResponse implements IAddressResponse {
    id?: string | undefined;
    streetLine?: string | undefined;
    streetLine2?: string | undefined;
    zipCode?: string | undefined;
    state?: string | undefined;
    country?: string | undefined;
    city?: string | undefined;

    constructor(data?: IAddressResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.streetLine = _data["streetLine"];
            this.streetLine2 = _data["streetLine2"];
            this.zipCode = _data["zipCode"];
            this.state = _data["state"];
            this.country = _data["country"];
            this.city = _data["city"];
        }
    }

    static fromJS(data: any): AddressResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AddressResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["streetLine"] = this.streetLine;
        data["streetLine2"] = this.streetLine2;
        data["zipCode"] = this.zipCode;
        data["state"] = this.state;
        data["country"] = this.country;
        data["city"] = this.city;
        return data; 
    }
}

export interface IAddressResponse {
    id?: string | undefined;
    streetLine?: string | undefined;
    streetLine2?: string | undefined;
    zipCode?: string | undefined;
    state?: string | undefined;
    country?: string | undefined;
    city?: string | undefined;
}

export class CreatedContactResponse implements ICreatedContactResponse {
    contactId!: string;

    constructor(data?: ICreatedContactResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contactId = _data["contactId"];
        }
    }

    static fromJS(data: any): CreatedContactResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreatedContactResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contactId"] = this.contactId;
        return data; 
    }
}

export interface ICreatedContactResponse {
    contactId: string;
}

export class ContactRequest implements IContactRequest {
    firstName!: string;
    lastName!: string;
    relation!: string;
    primaryContact!: boolean;
    guardian!: boolean;
    note?: string | undefined;
    contactInformation?: ContactInformationRequest | undefined;

    constructor(data?: IContactRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.relation = _data["relation"];
            this.primaryContact = _data["primaryContact"];
            this.guardian = _data["guardian"];
            this.note = _data["note"];
            this.contactInformation = _data["contactInformation"] ? ContactInformationRequest.fromJS(_data["contactInformation"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ContactRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ContactRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["relation"] = this.relation;
        data["primaryContact"] = this.primaryContact;
        data["guardian"] = this.guardian;
        data["note"] = this.note;
        data["contactInformation"] = this.contactInformation ? this.contactInformation.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IContactRequest {
    firstName: string;
    lastName: string;
    relation: string;
    primaryContact: boolean;
    guardian: boolean;
    note?: string | undefined;
    contactInformation?: ContactInformationRequest | undefined;
}

export class ContactInformationRequest implements IContactInformationRequest {
    address?: AddressRequest | undefined;
    phone?: string | undefined;
    email?: string | undefined;

    constructor(data?: IContactInformationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.address = _data["address"] ? AddressRequest.fromJS(_data["address"]) : <any>undefined;
            this.phone = _data["phone"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): ContactInformationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ContactInformationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["phone"] = this.phone;
        data["email"] = this.email;
        return data; 
    }
}

export interface IContactInformationRequest {
    address?: AddressRequest | undefined;
    phone?: string | undefined;
    email?: string | undefined;
}

export class AddressRequest implements IAddressRequest {
    streetLine?: string | undefined;
    streetLine2?: string | undefined;
    zipCode?: string | undefined;
    state?: string | undefined;
    country?: string | undefined;
    city?: string | undefined;

    constructor(data?: IAddressRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.streetLine = _data["streetLine"];
            this.streetLine2 = _data["streetLine2"];
            this.zipCode = _data["zipCode"];
            this.state = _data["state"];
            this.country = _data["country"];
            this.city = _data["city"];
        }
    }

    static fromJS(data: any): AddressRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddressRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["streetLine"] = this.streetLine;
        data["streetLine2"] = this.streetLine2;
        data["zipCode"] = this.zipCode;
        data["state"] = this.state;
        data["country"] = this.country;
        data["city"] = this.city;
        return data; 
    }
}

export interface IAddressRequest {
    streetLine?: string | undefined;
    streetLine2?: string | undefined;
    zipCode?: string | undefined;
    state?: string | undefined;
    country?: string | undefined;
    city?: string | undefined;
}

export class BasicInformationResponse implements IBasicInformationResponse {
    residentId?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    nickName?: string | undefined;
    dateOfBirth?: moment.Moment | undefined;
    ssn?: string | undefined;
    note?: string | undefined;
    maritalStatus?: string | undefined;
    religion?: string | undefined;
    contactInformation?: ContactInformationResponse | undefined;
    resuscitationInstructions?: string | undefined;
    riskOfContamination?: string | undefined;
    medicalAllergies?: string | undefined;
    allergies?: string | undefined;
    admission?: moment.Moment | undefined;
    discharge?: moment.Moment | undefined;
    anamnesis?: AnamnesisResponse | undefined;

    protected _discriminator: string;

    constructor(data?: IBasicInformationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "BasicInformationResponse";
    }

    init(_data?: any) {
        if (_data) {
            this.residentId = _data["residentId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.nickName = _data["nickName"];
            this.dateOfBirth = _data["dateOfBirth"] ? moment(_data["dateOfBirth"].toString()) : <any>undefined;
            this.ssn = _data["ssn"];
            this.note = _data["note"];
            this.maritalStatus = _data["maritalStatus"];
            this.religion = _data["religion"];
            this.contactInformation = _data["contactInformation"] ? ContactInformationResponse.fromJS(_data["contactInformation"]) : <any>undefined;
            this.resuscitationInstructions = _data["resuscitationInstructions"];
            this.riskOfContamination = _data["riskOfContamination"];
            this.medicalAllergies = _data["medicalAllergies"];
            this.allergies = _data["allergies"];
            this.admission = _data["admission"] ? moment(_data["admission"].toString()) : <any>undefined;
            this.discharge = _data["discharge"] ? moment(_data["discharge"].toString()) : <any>undefined;
            this.anamnesis = _data["anamnesis"] ? AnamnesisResponse.fromJS(_data["anamnesis"]) : <any>undefined;
        }
    }

    static fromJS(data: any): BasicInformationResponse {
        data = typeof data === 'object' ? data : {};
        if (data["discriminator"] === "DanishBasicInformationResponse") {
            let result = new DanishBasicInformationResponse();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "UkBasicInformationResponse") {
            let result = new UkBasicInformationResponse();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "SwedenBasicInformationResponse") {
            let result = new SwedenBasicInformationResponse();
            result.init(data);
            return result;
        }
        let result = new BasicInformationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["discriminator"] = this._discriminator; 
        data["residentId"] = this.residentId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["nickName"] = this.nickName;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.format('YYYY-MM-DD') : <any>undefined;
        data["ssn"] = this.ssn;
        data["note"] = this.note;
        data["maritalStatus"] = this.maritalStatus;
        data["religion"] = this.religion;
        data["contactInformation"] = this.contactInformation ? this.contactInformation.toJSON() : <any>undefined;
        data["resuscitationInstructions"] = this.resuscitationInstructions;
        data["riskOfContamination"] = this.riskOfContamination;
        data["medicalAllergies"] = this.medicalAllergies;
        data["allergies"] = this.allergies;
        data["admission"] = this.admission ? this.admission.format('YYYY-MM-DD') : <any>undefined;
        data["discharge"] = this.discharge ? this.discharge.format('YYYY-MM-DD') : <any>undefined;
        data["anamnesis"] = this.anamnesis ? this.anamnesis.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IBasicInformationResponse {
    residentId?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    nickName?: string | undefined;
    dateOfBirth?: moment.Moment | undefined;
    ssn?: string | undefined;
    note?: string | undefined;
    maritalStatus?: string | undefined;
    religion?: string | undefined;
    contactInformation?: ContactInformationResponse | undefined;
    resuscitationInstructions?: string | undefined;
    riskOfContamination?: string | undefined;
    medicalAllergies?: string | undefined;
    allergies?: string | undefined;
    admission?: moment.Moment | undefined;
    discharge?: moment.Moment | undefined;
    anamnesis?: AnamnesisResponse | undefined;
}

export class ContactInformationResponse implements IContactInformationResponse {
    id?: string | undefined;
    address?: AddressResponse | undefined;
    addressCo?: AddressResponse | undefined;
    billingAddress?: AddressResponse | undefined;
    phone?: string | undefined;
    email?: string | undefined;

    constructor(data?: IContactInformationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.address = _data["address"] ? AddressResponse.fromJS(_data["address"]) : <any>undefined;
            this.addressCo = _data["addressCo"] ? AddressResponse.fromJS(_data["addressCo"]) : <any>undefined;
            this.billingAddress = _data["billingAddress"] ? AddressResponse.fromJS(_data["billingAddress"]) : <any>undefined;
            this.phone = _data["phone"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): ContactInformationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ContactInformationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["addressCo"] = this.addressCo ? this.addressCo.toJSON() : <any>undefined;
        data["billingAddress"] = this.billingAddress ? this.billingAddress.toJSON() : <any>undefined;
        data["phone"] = this.phone;
        data["email"] = this.email;
        return data; 
    }
}

export interface IContactInformationResponse {
    id?: string | undefined;
    address?: AddressResponse | undefined;
    addressCo?: AddressResponse | undefined;
    billingAddress?: AddressResponse | undefined;
    phone?: string | undefined;
    email?: string | undefined;
}

export class AnamnesisResponse implements IAnamnesisResponse {
    contactReason?: string | undefined;
    healthHistory?: string | undefined;
    ongoingCare?: string | undefined;
    socialBackgroundAndLifestyle?: string | undefined;

    constructor(data?: IAnamnesisResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contactReason = _data["contactReason"];
            this.healthHistory = _data["healthHistory"];
            this.ongoingCare = _data["ongoingCare"];
            this.socialBackgroundAndLifestyle = _data["socialBackgroundAndLifestyle"];
        }
    }

    static fromJS(data: any): AnamnesisResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AnamnesisResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contactReason"] = this.contactReason;
        data["healthHistory"] = this.healthHistory;
        data["ongoingCare"] = this.ongoingCare;
        data["socialBackgroundAndLifestyle"] = this.socialBackgroundAndLifestyle;
        return data; 
    }
}

export interface IAnamnesisResponse {
    contactReason?: string | undefined;
    healthHistory?: string | undefined;
    ongoingCare?: string | undefined;
    socialBackgroundAndLifestyle?: string | undefined;
}

export class DanishBasicInformationResponse extends BasicInformationResponse implements IDanishBasicInformationResponse {
    kroniskeSygdommeOgHandicap?: string | undefined;
    samtykkekompetence?: string | undefined;
    diagnoser?: string | undefined;
    medicinadministrering?: string | undefined;

    constructor(data?: IDanishBasicInformationResponse) {
        super(data);
        this._discriminator = "DanishBasicInformationResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.kroniskeSygdommeOgHandicap = _data["kroniskeSygdommeOgHandicap"];
            this.samtykkekompetence = _data["samtykkekompetence"];
            this.diagnoser = _data["diagnoser"];
            this.medicinadministrering = _data["medicinadministrering"];
        }
    }

    static fromJS(data: any): DanishBasicInformationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DanishBasicInformationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kroniskeSygdommeOgHandicap"] = this.kroniskeSygdommeOgHandicap;
        data["samtykkekompetence"] = this.samtykkekompetence;
        data["diagnoser"] = this.diagnoser;
        data["medicinadministrering"] = this.medicinadministrering;
        super.toJSON(data);
        return data; 
    }
}

export interface IDanishBasicInformationResponse extends IBasicInformationResponse {
    kroniskeSygdommeOgHandicap?: string | undefined;
    samtykkekompetence?: string | undefined;
    diagnoser?: string | undefined;
    medicinadministrering?: string | undefined;
}

export class UkBasicInformationResponse extends BasicInformationResponse implements IUkBasicInformationResponse {
    nhsNumber?: string | undefined;
    niNumber?: string | undefined;
    gender!: ResidentGender;
    sexualOrientation?: string | undefined;
    ethnicity?: string | undefined;
    pronouns?: string | undefined;
    doLS?: string | undefined;
    summaryOfKnownConditions?: string | undefined;

    constructor(data?: IUkBasicInformationResponse) {
        super(data);
        this._discriminator = "UkBasicInformationResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.nhsNumber = _data["nhsNumber"];
            this.niNumber = _data["niNumber"];
            this.gender = _data["gender"];
            this.sexualOrientation = _data["sexualOrientation"];
            this.ethnicity = _data["ethnicity"];
            this.pronouns = _data["pronouns"];
            this.doLS = _data["doLS"];
            this.summaryOfKnownConditions = _data["summaryOfKnownConditions"];
        }
    }

    static fromJS(data: any): UkBasicInformationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UkBasicInformationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nhsNumber"] = this.nhsNumber;
        data["niNumber"] = this.niNumber;
        data["gender"] = this.gender;
        data["sexualOrientation"] = this.sexualOrientation;
        data["ethnicity"] = this.ethnicity;
        data["pronouns"] = this.pronouns;
        data["doLS"] = this.doLS;
        data["summaryOfKnownConditions"] = this.summaryOfKnownConditions;
        super.toJSON(data);
        return data; 
    }
}

export interface IUkBasicInformationResponse extends IBasicInformationResponse {
    nhsNumber?: string | undefined;
    niNumber?: string | undefined;
    gender: ResidentGender;
    sexualOrientation?: string | undefined;
    ethnicity?: string | undefined;
    pronouns?: string | undefined;
    doLS?: string | undefined;
    summaryOfKnownConditions?: string | undefined;
}

export class SwedenBasicInformationResponse extends BasicInformationResponse implements ISwedenBasicInformationResponse {
    personnummer?: string | undefined;
    flykting!: boolean;
    enpersonshushåll!: boolean;
    gallringsuntag!: boolean;
    skyddad!: boolean;
    samtyckerNationellaKvalitetsregister!: boolean;
    samtyckerBilder!: boolean;
    samtyckerOmsorgsdokumentation!: boolean;
    samtyckerVårdgivare!: boolean;
    identitetskontroll!: boolean;
    informationSomKanLedaTillSärskildVårdrutin?: string | undefined;

    constructor(data?: ISwedenBasicInformationResponse) {
        super(data);
        this._discriminator = "SwedenBasicInformationResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.personnummer = _data["personnummer"];
            this.flykting = _data["flykting"];
            this.enpersonshushåll = _data["enpersonshushåll"];
            this.gallringsuntag = _data["gallringsuntag"];
            this.skyddad = _data["skyddad"];
            this.samtyckerNationellaKvalitetsregister = _data["samtyckerNationellaKvalitetsregister"];
            this.samtyckerBilder = _data["samtyckerBilder"];
            this.samtyckerOmsorgsdokumentation = _data["samtyckerOmsorgsdokumentation"];
            this.samtyckerVårdgivare = _data["samtyckerVårdgivare"];
            this.identitetskontroll = _data["identitetskontroll"];
            this.informationSomKanLedaTillSärskildVårdrutin = _data["informationSomKanLedaTillSärskildVårdrutin"];
        }
    }

    static fromJS(data: any): SwedenBasicInformationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SwedenBasicInformationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personnummer"] = this.personnummer;
        data["flykting"] = this.flykting;
        data["enpersonshushåll"] = this.enpersonshushåll;
        data["gallringsuntag"] = this.gallringsuntag;
        data["skyddad"] = this.skyddad;
        data["samtyckerNationellaKvalitetsregister"] = this.samtyckerNationellaKvalitetsregister;
        data["samtyckerBilder"] = this.samtyckerBilder;
        data["samtyckerOmsorgsdokumentation"] = this.samtyckerOmsorgsdokumentation;
        data["samtyckerVårdgivare"] = this.samtyckerVårdgivare;
        data["identitetskontroll"] = this.identitetskontroll;
        data["informationSomKanLedaTillSärskildVårdrutin"] = this.informationSomKanLedaTillSärskildVårdrutin;
        super.toJSON(data);
        return data; 
    }
}

export interface ISwedenBasicInformationResponse extends IBasicInformationResponse {
    personnummer?: string | undefined;
    flykting: boolean;
    enpersonshushåll: boolean;
    gallringsuntag: boolean;
    skyddad: boolean;
    samtyckerNationellaKvalitetsregister: boolean;
    samtyckerBilder: boolean;
    samtyckerOmsorgsdokumentation: boolean;
    samtyckerVårdgivare: boolean;
    identitetskontroll: boolean;
    informationSomKanLedaTillSärskildVårdrutin?: string | undefined;
}

export class EditBasicInformationRequest implements IEditBasicInformationRequest {
    residentId?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    nickName?: string | undefined;
    dateOfBirth?: moment.Moment | undefined;
    ssn?: string | undefined;
    note?: string | undefined;
    maritalStatus?: string | undefined;
    religion?: string | undefined;
    contactInformation?: EditContactInformationRequest | undefined;
    resuscitationInstructions?: string | undefined;
    riskOfContamination?: string | undefined;
    medicalAllergies?: string | undefined;
    allergies?: string | undefined;
    admission?: moment.Moment | undefined;
    discharge?: moment.Moment | undefined;
    anamnesis?: EditAnamnesisRequest | undefined;

    protected _discriminator: string;

    constructor(data?: IEditBasicInformationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "EditBasicInformationRequest";
    }

    init(_data?: any) {
        if (_data) {
            this.residentId = _data["residentId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.nickName = _data["nickName"];
            this.dateOfBirth = _data["dateOfBirth"] ? moment(_data["dateOfBirth"].toString()) : <any>undefined;
            this.ssn = _data["ssn"];
            this.note = _data["note"];
            this.maritalStatus = _data["maritalStatus"];
            this.religion = _data["religion"];
            this.contactInformation = _data["contactInformation"] ? EditContactInformationRequest.fromJS(_data["contactInformation"]) : <any>undefined;
            this.resuscitationInstructions = _data["resuscitationInstructions"];
            this.riskOfContamination = _data["riskOfContamination"];
            this.medicalAllergies = _data["medicalAllergies"];
            this.allergies = _data["allergies"];
            this.admission = _data["admission"] ? moment(_data["admission"].toString()) : <any>undefined;
            this.discharge = _data["discharge"] ? moment(_data["discharge"].toString()) : <any>undefined;
            this.anamnesis = _data["anamnesis"] ? EditAnamnesisRequest.fromJS(_data["anamnesis"]) : <any>undefined;
        }
    }

    static fromJS(data: any): EditBasicInformationRequest {
        data = typeof data === 'object' ? data : {};
        if (data["discriminator"] === "EditUkBasicInformationRequest") {
            let result = new EditUkBasicInformationRequest();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "EditSwedenBasicInformationRequest") {
            let result = new EditSwedenBasicInformationRequest();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "EditDanishBasicInformationRequest") {
            let result = new EditDanishBasicInformationRequest();
            result.init(data);
            return result;
        }
        let result = new EditBasicInformationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["discriminator"] = this._discriminator; 
        data["residentId"] = this.residentId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["nickName"] = this.nickName;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.format('YYYY-MM-DD') : <any>undefined;
        data["ssn"] = this.ssn;
        data["note"] = this.note;
        data["maritalStatus"] = this.maritalStatus;
        data["religion"] = this.religion;
        data["contactInformation"] = this.contactInformation ? this.contactInformation.toJSON() : <any>undefined;
        data["resuscitationInstructions"] = this.resuscitationInstructions;
        data["riskOfContamination"] = this.riskOfContamination;
        data["medicalAllergies"] = this.medicalAllergies;
        data["allergies"] = this.allergies;
        data["admission"] = this.admission ? this.admission.format('YYYY-MM-DD') : <any>undefined;
        data["discharge"] = this.discharge ? this.discharge.format('YYYY-MM-DD') : <any>undefined;
        data["anamnesis"] = this.anamnesis ? this.anamnesis.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IEditBasicInformationRequest {
    residentId?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    nickName?: string | undefined;
    dateOfBirth?: moment.Moment | undefined;
    ssn?: string | undefined;
    note?: string | undefined;
    maritalStatus?: string | undefined;
    religion?: string | undefined;
    contactInformation?: EditContactInformationRequest | undefined;
    resuscitationInstructions?: string | undefined;
    riskOfContamination?: string | undefined;
    medicalAllergies?: string | undefined;
    allergies?: string | undefined;
    admission?: moment.Moment | undefined;
    discharge?: moment.Moment | undefined;
    anamnesis?: EditAnamnesisRequest | undefined;
}

export class EditContactInformationRequest implements IEditContactInformationRequest {
    id?: string | undefined;
    address?: EditAddressRequest | undefined;
    addressCo?: EditAddressRequest | undefined;
    billingAddress?: EditAddressRequest | undefined;
    phone?: string | undefined;
    email?: string | undefined;

    constructor(data?: IEditContactInformationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.address = _data["address"] ? EditAddressRequest.fromJS(_data["address"]) : <any>undefined;
            this.addressCo = _data["addressCo"] ? EditAddressRequest.fromJS(_data["addressCo"]) : <any>undefined;
            this.billingAddress = _data["billingAddress"] ? EditAddressRequest.fromJS(_data["billingAddress"]) : <any>undefined;
            this.phone = _data["phone"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): EditContactInformationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new EditContactInformationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["addressCo"] = this.addressCo ? this.addressCo.toJSON() : <any>undefined;
        data["billingAddress"] = this.billingAddress ? this.billingAddress.toJSON() : <any>undefined;
        data["phone"] = this.phone;
        data["email"] = this.email;
        return data; 
    }
}

export interface IEditContactInformationRequest {
    id?: string | undefined;
    address?: EditAddressRequest | undefined;
    addressCo?: EditAddressRequest | undefined;
    billingAddress?: EditAddressRequest | undefined;
    phone?: string | undefined;
    email?: string | undefined;
}

export class EditAddressRequest implements IEditAddressRequest {
    id?: string | undefined;
    streetLine?: string | undefined;
    streetLine2?: string | undefined;
    zipCode?: string | undefined;
    state?: string | undefined;
    country?: string | undefined;
    city?: string | undefined;

    constructor(data?: IEditAddressRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.streetLine = _data["streetLine"];
            this.streetLine2 = _data["streetLine2"];
            this.zipCode = _data["zipCode"];
            this.state = _data["state"];
            this.country = _data["country"];
            this.city = _data["city"];
        }
    }

    static fromJS(data: any): EditAddressRequest {
        data = typeof data === 'object' ? data : {};
        let result = new EditAddressRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["streetLine"] = this.streetLine;
        data["streetLine2"] = this.streetLine2;
        data["zipCode"] = this.zipCode;
        data["state"] = this.state;
        data["country"] = this.country;
        data["city"] = this.city;
        return data; 
    }
}

export interface IEditAddressRequest {
    id?: string | undefined;
    streetLine?: string | undefined;
    streetLine2?: string | undefined;
    zipCode?: string | undefined;
    state?: string | undefined;
    country?: string | undefined;
    city?: string | undefined;
}

export class EditAnamnesisRequest implements IEditAnamnesisRequest {
    contactReason?: string | undefined;
    healthHistory?: string | undefined;
    ongoingCare?: string | undefined;
    socialBackgroundAndLifestyle?: string | undefined;

    constructor(data?: IEditAnamnesisRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contactReason = _data["contactReason"];
            this.healthHistory = _data["healthHistory"];
            this.ongoingCare = _data["ongoingCare"];
            this.socialBackgroundAndLifestyle = _data["socialBackgroundAndLifestyle"];
        }
    }

    static fromJS(data: any): EditAnamnesisRequest {
        data = typeof data === 'object' ? data : {};
        let result = new EditAnamnesisRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contactReason"] = this.contactReason;
        data["healthHistory"] = this.healthHistory;
        data["ongoingCare"] = this.ongoingCare;
        data["socialBackgroundAndLifestyle"] = this.socialBackgroundAndLifestyle;
        return data; 
    }
}

export interface IEditAnamnesisRequest {
    contactReason?: string | undefined;
    healthHistory?: string | undefined;
    ongoingCare?: string | undefined;
    socialBackgroundAndLifestyle?: string | undefined;
}

export class EditUkBasicInformationRequest extends EditBasicInformationRequest implements IEditUkBasicInformationRequest {
    nhsNumber?: string | undefined;
    niNumber?: string | undefined;
    gender!: ResidentGender;
    sexualOrientation?: string | undefined;
    ethnicity?: string | undefined;
    pronouns?: string | undefined;
    doLS?: string | undefined;
    summaryOfKnownConditions?: string | undefined;

    constructor(data?: IEditUkBasicInformationRequest) {
        super(data);
        this._discriminator = "EditUkBasicInformationRequest";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.nhsNumber = _data["nhsNumber"];
            this.niNumber = _data["niNumber"];
            this.gender = _data["gender"];
            this.sexualOrientation = _data["sexualOrientation"];
            this.ethnicity = _data["ethnicity"];
            this.pronouns = _data["pronouns"];
            this.doLS = _data["doLS"];
            this.summaryOfKnownConditions = _data["summaryOfKnownConditions"];
        }
    }

    static fromJS(data: any): EditUkBasicInformationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new EditUkBasicInformationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nhsNumber"] = this.nhsNumber;
        data["niNumber"] = this.niNumber;
        data["gender"] = this.gender;
        data["sexualOrientation"] = this.sexualOrientation;
        data["ethnicity"] = this.ethnicity;
        data["pronouns"] = this.pronouns;
        data["doLS"] = this.doLS;
        data["summaryOfKnownConditions"] = this.summaryOfKnownConditions;
        super.toJSON(data);
        return data; 
    }
}

export interface IEditUkBasicInformationRequest extends IEditBasicInformationRequest {
    nhsNumber?: string | undefined;
    niNumber?: string | undefined;
    gender: ResidentGender;
    sexualOrientation?: string | undefined;
    ethnicity?: string | undefined;
    pronouns?: string | undefined;
    doLS?: string | undefined;
    summaryOfKnownConditions?: string | undefined;
}

export class EditSwedenBasicInformationRequest extends EditBasicInformationRequest implements IEditSwedenBasicInformationRequest {
    personnummer?: string | undefined;
    flykting!: boolean;
    enpersonshushåll!: boolean;
    gallringsuntag!: boolean;
    skyddad!: boolean;
    samtyckerNationellaKvalitetsregister!: boolean;
    samtyckerBilder!: boolean;
    samtyckerOmsorgsdokumentation!: boolean;
    samtyckerVårdgivare!: boolean;
    identitetskontroll!: boolean;
    informationSomKanLedaTillSärskildVårdrutin?: string | undefined;

    constructor(data?: IEditSwedenBasicInformationRequest) {
        super(data);
        this._discriminator = "EditSwedenBasicInformationRequest";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.personnummer = _data["personnummer"];
            this.flykting = _data["flykting"];
            this.enpersonshushåll = _data["enpersonshushåll"];
            this.gallringsuntag = _data["gallringsuntag"];
            this.skyddad = _data["skyddad"];
            this.samtyckerNationellaKvalitetsregister = _data["samtyckerNationellaKvalitetsregister"];
            this.samtyckerBilder = _data["samtyckerBilder"];
            this.samtyckerOmsorgsdokumentation = _data["samtyckerOmsorgsdokumentation"];
            this.samtyckerVårdgivare = _data["samtyckerVårdgivare"];
            this.identitetskontroll = _data["identitetskontroll"];
            this.informationSomKanLedaTillSärskildVårdrutin = _data["informationSomKanLedaTillSärskildVårdrutin"];
        }
    }

    static fromJS(data: any): EditSwedenBasicInformationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new EditSwedenBasicInformationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personnummer"] = this.personnummer;
        data["flykting"] = this.flykting;
        data["enpersonshushåll"] = this.enpersonshushåll;
        data["gallringsuntag"] = this.gallringsuntag;
        data["skyddad"] = this.skyddad;
        data["samtyckerNationellaKvalitetsregister"] = this.samtyckerNationellaKvalitetsregister;
        data["samtyckerBilder"] = this.samtyckerBilder;
        data["samtyckerOmsorgsdokumentation"] = this.samtyckerOmsorgsdokumentation;
        data["samtyckerVårdgivare"] = this.samtyckerVårdgivare;
        data["identitetskontroll"] = this.identitetskontroll;
        data["informationSomKanLedaTillSärskildVårdrutin"] = this.informationSomKanLedaTillSärskildVårdrutin;
        super.toJSON(data);
        return data; 
    }
}

export interface IEditSwedenBasicInformationRequest extends IEditBasicInformationRequest {
    personnummer?: string | undefined;
    flykting: boolean;
    enpersonshushåll: boolean;
    gallringsuntag: boolean;
    skyddad: boolean;
    samtyckerNationellaKvalitetsregister: boolean;
    samtyckerBilder: boolean;
    samtyckerOmsorgsdokumentation: boolean;
    samtyckerVårdgivare: boolean;
    identitetskontroll: boolean;
    informationSomKanLedaTillSärskildVårdrutin?: string | undefined;
}

export class EditDanishBasicInformationRequest extends EditBasicInformationRequest implements IEditDanishBasicInformationRequest {
    kroniskeSygdommeOgHandicap?: string | undefined;
    samtykkekompetence?: string | undefined;
    diagnoser?: string | undefined;
    medicinadministrering?: string | undefined;

    constructor(data?: IEditDanishBasicInformationRequest) {
        super(data);
        this._discriminator = "EditDanishBasicInformationRequest";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.kroniskeSygdommeOgHandicap = _data["kroniskeSygdommeOgHandicap"];
            this.samtykkekompetence = _data["samtykkekompetence"];
            this.diagnoser = _data["diagnoser"];
            this.medicinadministrering = _data["medicinadministrering"];
        }
    }

    static fromJS(data: any): EditDanishBasicInformationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new EditDanishBasicInformationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kroniskeSygdommeOgHandicap"] = this.kroniskeSygdommeOgHandicap;
        data["samtykkekompetence"] = this.samtykkekompetence;
        data["diagnoser"] = this.diagnoser;
        data["medicinadministrering"] = this.medicinadministrering;
        super.toJSON(data);
        return data; 
    }
}

export interface IEditDanishBasicInformationRequest extends IEditBasicInformationRequest {
    kroniskeSygdommeOgHandicap?: string | undefined;
    samtykkekompetence?: string | undefined;
    diagnoser?: string | undefined;
    medicinadministrering?: string | undefined;
}

export class IdResponse implements IIdResponse {
    id!: string;

    constructor(data?: IIdResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): IdResponse {
        data = typeof data === 'object' ? data : {};
        let result = new IdResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data; 
    }
}

export interface IIdResponse {
    id: string;
}

export class CreateAccessControlTagRequest implements ICreateAccessControlTagRequest {
    name!: string;

    constructor(data?: ICreateAccessControlTagRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CreateAccessControlTagRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAccessControlTagRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data; 
    }
}

export interface ICreateAccessControlTagRequest {
    name: string;
}

export class AccessControlTagResponse implements IAccessControlTagResponse {
    id!: string;
    name!: string;

    constructor(data?: IAccessControlTagResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): AccessControlTagResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AccessControlTagResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data; 
    }
}

export interface IAccessControlTagResponse {
    id: string;
    name: string;
}

export class RenameAccessControlTagRequest implements IRenameAccessControlTagRequest {
    name!: string;

    constructor(data?: IRenameAccessControlTagRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): RenameAccessControlTagRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RenameAccessControlTagRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data; 
    }
}

export interface IRenameAccessControlTagRequest {
    name: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}